// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:28:15.170Z
// Property: The Logan (ID: 5767160559304704)
// Collections: 20 amenities, 13 floorplans (live), 14 photos, 83 POIs, 4 reviews, 6 virtual tours, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5767160559304704",
  "property_external_id": "4520341",
  "property_zillow_url": "https://www.zillow.com/homedetails/1404-Country-Meadows-Dr-Bedford-TX-76021/29202784_zpid/",
  "property_apartments_url": "https://www.apartments.com/the-logan-bedford-tx/rsj1wn1",
  "property_google_business_url": "https://www.google.com/maps/place/The+Logan/@32.8415021,-97.1481044,17z/data=!4m13!1m7!3m6!1s0x864e7f0ff739ee0f:0x8f75c0594774c511!2s1400+Sierra+Springs+Dr,+Bedford,+TX+76021!3b1!8m2!3d32.8420111!4d-97.1446877!3m4!1s0x864e7f055a8fc76b:0x26d4ee9ccd8df29c!8m2!3d32.8419727!4d-97.144764",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443251725",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-logan",
  "property_name": "The Logan",
  "property_website_url": "https://www.theloganapartments.com/",
  "property_domain": "https://www.theloganapartments.com/",
  "property_address": "1400 Sierra Springs Dr",
  "property_full_address": "1400 Sierra Springs Dr, Bedford, TX 76021",
  "property_address_1": "1400 Sierra Springs Dr",
  "property_address_2": null,
  "property_address_city": "Bedford",
  "property_address_state": "TX",
  "property_address_zip_full": "76021-5671",
  "property_address_zip": "76021",
  "property_address_country": "US",
  "property_address_county": "Tarrant County",
  "property_neighborhood_address": "Hurst/Euless/Bedford",
  "property_address_latitude": "32.8404679",
  "property_address_longitude": "-97.1468134",
  "property_email": "thelogan@alapts.com",
  "property_phone": "(817) 540-4044",
  "property_call_tracking_phone": "817-767-1807",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Mid-Cities ease, polished everyday comfort.</strong> The Logan pairs one- and two-bedroom <a href=\"/floor-plans\">apartment layouts</a> with granite kitchens, washer/dryer connections, and private patios or balconies—plus quick access across Bedford and the DFW area. <a href=\"/schedule-a-tour\">Schedule a tour</a> to see it in person.</p>",
  "property_long_description": "<p><strong>Mid-Cities ease, polished everyday comfort.</strong> At The Logan, you’re set in Bedford’s Hurst/Euless/Bedford area with quick access to Highway 183, TX-121, and I-820—making DFW Airport, Fort Worth, Arlington, and Dallas easy to reach.</p><p>Choose from comfortable one- and two-bedroom <a href=\"/floor-plans\">apartment layouts</a> with the details that make daily life feel streamlined: gourmet kitchens with granite countertops and stainless steel appliances, full-size washer/dryer connections, walk-in closets, private patios or balconies, and select-home upgrades like fireplaces, vaulted ceilings, spiral staircases, and wood-style flooring.</p><p>Outside your door, two swimming pools, a fitness center, tennis court, clubhouse, grilling areas, package lockers, bark park, and pet spa add convenience and breathing room. When you’re ready to get out, Generations Park at Boys Ranch, North East Mall, Spring Creek Barbeque, Twisted Root Burger Co., and everyday shopping and dining are all close to home. Explore more on the <a href=\"/neighborhood\">neighborhood</a> page, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see The Logan in person.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f4-cbae-73d3-815a-1e27e24948c2.webp",
  "property_featured_image_media": {
    "alt_text": "Spacious community lounge with a stone fireplace, comfortable seating, and modern decor.",
    "public_id": "019d02f4-cbae-73d3-815a-1e27e24948c2",
    "storage_key": "property/5767160559304704/019d02f4-cbae-73d3-815a-1e27e24948c2.webp",
    "width": 1240,
    "height": 827
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "490",
  "property_year_built": "1984",
  "property_year_renovated": "2019",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.48979591836735",
  "property_admin_fee": "150",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Application Fee $75\nAdministrative Fee $150\nNon-Refundable Pet Fee $300 / pet\nMonthly Pet Rent $20 / pet\nApplication Approval Fee Starting At $300\n",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "20",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $20 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $20 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://7850096.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://thelogan.loftliving.com/login",
  "property_apply_now_url": "https://7850096.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019e73e8-21a0-76c0-920e-64d779301568.webp",
  "property_primary_logo_media": {
    "alt_text": "The Logan Premier Apartments logo",
    "public_id": "019e73e8-21a0-76c0-920e-64d779301568",
    "storage_key": "property/5767160559304704/019e73e8-21a0-76c0-920e-64d779301568.webp",
    "width": 1250,
    "height": 419
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019e73e8-2446-7403-bda5-e90f15db1f34.webp",
  "property_secondary_logo_media": {
    "alt_text": "The Logan logo",
    "public_id": "019e73e8-2446-7403-bda5-e90f15db1f34",
    "storage_key": "property/5767160559304704/019e73e8-2446-7403-bda5-e90f15db1f34.webp",
    "width": 1250,
    "height": 419
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019e73e8-223d-75d8-ba47-c3cc883d70ea.webp",
  "property_icon_media": {
    "alt_text": "The Logan Premier Apartments logo",
    "public_id": "019e73e8-223d-75d8-ba47-c3cc883d70ea",
    "storage_key": "property/5767160559304704/019e73e8-223d-75d8-ba47-c3cc883d70ea.webp",
    "width": 528,
    "height": 527
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019e73e8-223d-75d8-ba47-c3cc883d70ea.webp",
  "property_fav_icon_media": {
    "alt_text": "The Logan Premier Apartments logo",
    "public_id": "019e73e8-223d-75d8-ba47-c3cc883d70ea",
    "storage_key": "property/5767160559304704/019e73e8-223d-75d8-ba47-c3cc883d70ea.webp",
    "width": 528,
    "height": 527
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f6759-dbb0-739b-bbb4-75e116fbbb36.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019f6759-dbb0-739b-bbb4-75e116fbbb36",
    "storage_key": "property/5767160559304704/019f6759-dbb0-739b-bbb4-75e116fbbb36.webp",
    "width": 1250,
    "height": 419
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f6759-ceeb-73e4-8909-9cbdd5ac09c4.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f6759-ceeb-73e4-8909-9cbdd5ac09c4",
    "storage_key": "property/5767160559304704/019f6759-ceeb-73e4-8909-9cbdd5ac09c4.webp",
    "width": 1250,
    "height": 419
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#006ba7",
  "property_secondary_color": "#ef7100",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#808285",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "551 - 1105",
  "property_sqft_min": "551",
  "property_sqft_max": "1105",
  "property_price_range": "1119 - 1706.66",
  "property_price_min": "1119",
  "property_price_max": "1706.66",
  "property_available_units": 27,
  "property_facebook_url": "https://www.facebook.com/TheLoganApts",
  "property_instagram_url": "https://www.instagram.com/theloganapartmentsTX",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJa8ePWgV_ToYRnPKNzZzu1CY",
  "property_youtube_url": "https://www.youtube.com/watch?v=uIEFdoaB_qE",
  "property_yelp_url": "https://www.yelp.com/biz/the-logan-bedford-5",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Everyday convenience, resort-inspired downtime.</strong> At The Logan in Bedford, amenities make it easy to keep your day moving—from package lockers and 24/7 online resident services to a fitness center, tennis court, grilling areas, bark park, pet spa, and two sparkling pools.</p><p>Inside, enjoy granite countertops, stainless-steel appliances, designer cabinetry, walk-in closets, and a private patio or balcony, with select homes adding fireplaces, vaulted ceilings, spiral staircases, or wood-style flooring.</p>",
  "property_home_floorplans_blurb": "<p><strong>Layouts with room to live your way.</strong> Explore one- and two-bedroom apartments in Bedford with smart space, stylish kitchens, walk-in closets, full-size washer/dryer connections, and private patios or balconies. Select homes add standout touches like fireplaces, vaulted ceilings, spiral staircases, or wood-style flooring—giving each floor plan its own distinct feel.</p>",
  "property_home_gallery_blurb": "<p><strong>See The Logan from every angle.</strong> Preview stainless-steel kitchens with custom countertops, open living spaces with patios or balconies, and select details like fireplaces, vaulted ceilings, or spiral staircases. Then browse the full gallery for a closer look at two sparkling pools, lounge areas, grilling spaces, the fitness center, tennis court, bark park, and pet spa before exploring <a href=\"/virtual-tours\">virtual tours</a> or planning an in-person visit.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Connected Bedford living starts here.</strong> From The Logan, Airport Freeway puts DFW Airport, Arlington, Fort Worth, and Dallas within easy reach, while Hurst, Euless, and Bedford stay close for everyday plans. Grab brunch at Wood &amp; Grain Bistro or Oldwest Cafe, browse North East Mall, catch a movie, or unwind at Generations Park at Boys Ranch with lake views, trails, fields, and local events nearby.</p>",
  "property_home_reviews_blurb": "<p><strong>Resident reviews bring The Logan to life.</strong> Highlights include responsive maintenance, helpful office staff, clean shared spaces, and well-kept landscaping that adds to the community’s calm, cared-for feel.</p><p>Reviews also mention refreshed finishes, a quiet atmosphere, and a convenient Bedford location near grocery shopping and restaurants. Read more to see what day-to-day living at The Logan is like.</p>",
  "property_neighborhood_blurb": "<p><strong>Bedford puts the Metroplex within easy reach.</strong> From The Logan, you’re positioned for quick hops across Hurst, Euless, and Bedford, with Airport Freeway keeping DFW Airport, Arlington, Fort Worth, and Dallas connected to your day. Close to home, plans can shift from brunch at Wood &amp; Grain Bistro or Oldwest Cafe to shopping and a movie around North East Mall, then back to your own comfortable retreat.</p><p>When you want more room to roam, Generations Park at Boys Ranch brings lake views, trails, fields, an events lawn, and local Bedford happenings into your orbit. Explore the map to see how everyday stops, weekend plans, and green space connect around The Logan—then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the location in person.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that make every day feel more put-together.</strong> At The Logan in Bedford, you can move easily from practical errands to relaxing downtime: pick up deliveries from package lockers, manage requests through 24/7 online resident services, fit in a workout, or unwind by one of two resort-inspired swimming pools.</p><p>Outdoor space adds more ways to enjoy the community, from grilling areas and a tennis court to a bark park and pet spa—check the <a href=\"/pet-policy\">pet policy</a> for details. Inside your apartment, gourmet kitchens with granite countertops, stainless-steel appliances, designer cabinetry, walk-in closets, and a private patio or balcony bring comfort into focus, with select homes offering fireplaces, vaulted ceilings, spiral staircases, or wood-style flooring. See it all in the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_applynow_blurb": "<p><strong>Ready for polished Bedford living?</strong> The Logan pairs comfortable one- and two-bedroom layouts with everyday ease—granite countertops, stainless steel appliances, washer/dryer connections, walk-in closets, and private outdoor space. Start your online application today and take the next step toward calling The Logan home.</p>",
  "property_contactus_blurb": "<p><strong>Questions? Need directions?</strong> Reach out to The Logan leasing team for help finding your way to our Bedford community near Highway 183, TX-121, and I-820, or to learn more about our one- and two-bedroom apartment layouts. We’re here to make your next step simple.</p>",
  "property_faqs_blurb": "<p><strong>Questions about The Logan?</strong> Start here for quick answers about the community, leasing, amenities, policies, and everyday life in Bedford’s Hurst/Euless/Bedford area. If you need more details or want help choosing a one- or two-bedroom layout, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits the way you use home.</strong> The Logan’s one- and two-bedroom apartments in Bedford range from efficient, easy-to-style spaces to roomier two-bath layouts with more separation for work, hosting, storage, or simply stretching out.</p><p>Inside, everyday details feel considered: gourmet kitchens with custom countertops, stainless steel appliances, designer cabinetry, walk-in closets, full-size washer/dryer connections, and private patios or balconies. Select homes add character with fireplaces, vaulted ceilings, spiral staircases, or wood-style flooring. Browse current availability, compare your favorite layouts, then explore the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how each floor plan lives in person.</p>",
  "property_gallery_blurb": "<p><strong>Picture the day-to-day before you tour.</strong> Browse The Logan’s photo gallery and see crisp kitchen scenes with stainless-steel appliances, custom countertops, and designer cabinetry; living areas that open to private patios or balconies; and select-home details like fireplaces, vaulted ceilings, or spiral staircases that add a little extra character.</p><p>Outside, the images move through the Bedford community’s two sparkling pools, pool lounge areas, grilling spaces, fitness center, tennis court, bark park, and pet spa—so you can connect each space to how it looks and feels in real life. Compare the gallery with <a href=\"/floor-plans\">available layouts</a>, explore <a href=\"/virtual-tours\">virtual tours</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite views up close.</p>",
  "property_interactivemap_blurb": "<p><strong>Map your next move.</strong> Use the interactive map to explore available apartments at The Logan and see how Bedford’s Hurst/Euless/Bedford location connects you to Highway 183, TX-121, I-820, and nearby shopping, dining, parks, and entertainment.</p>",
  "property_pets_blurb": "<p><strong>Start with the wag, not the workaround.</strong> At The Logan, cats and dogs are welcome, and pet-friendly living feels easy to work into the everyday routine. Head to the spacious bark park for fresh air and playtime, rinse off muddy paws at the pet spa, then settle back into an apartment with comfortable interiors and options like private patios or balconies.</p><p>When your pet needs a bigger change of scenery, Bedford’s city Bark Park adds off-site room to roam with separate small- and large-dog areas, water fountains, agility equipment, and clean-up stations. Explore more community features on the <a href=\"/amenities\">amenities page</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how The Logan fits your pet-friendly routine.</p>",
  "property_referafriend_blurb": "<p><strong>Share The Logan with a friend.</strong> If you love the Mid-Cities ease, polished apartment finishes, and everyday convenience at The Logan, invite someone you know to experience it too. Send a referral and help them find comfortable Bedford living with quick access across the DFW area.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at The Logan.</strong><br>Keep everyday living streamlined from your account: pay rent, submit maintenance requests, and manage details in one convenient place—so you can get back to enjoying polished comfort in Bedford’s Hurst/Euless/Bedford area.</p>",
  "property_reviews_blurb": "<p><strong>See The Logan through resident experiences.</strong> Reviews highlight the everyday details that matter: responsive maintenance, helpful office staff, well-kept landscaping, and clean shared spaces like the pool, laundry room, and gym.</p><p>Residents also call out the property’s quiet feel, refreshed finishes, and convenient setting near grocery shopping and restaurants. As one reviewer put it, “the grounds are clean and it’s pretty quiet.” Browse the reviews below to get a clearer sense of what living at The Logan feels like day to day.</p>",
  "property_created_at": "1752256750059",
  "property_scheduletour_blurb": "<p><strong>See polished comfort up close.</strong> Tour The Logan and picture everyday ease with granite countertops, stainless steel appliances, walk-in closets, private outdoor space, and quick access across the Mid-Cities. Schedule your visit today and experience the details in person.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong><br> The Logan leasing team will follow up soon. In the meantime, picture polished everyday comfort in Bedford’s Hurst/Euless/Bedford area, with one- and two-bedroom layouts, streamlined apartment finishes, and easy access to Highway 183, TX-121, and I-820.</p>",
  "property_virtualtours_blurb": "<p><strong>Tour The Logan from wherever you are.</strong> Start with the community views, then move at your own pace through the spaces that make the property feel complete: the state-of-the-art fitness center, Resort-Inspired Pool 2, the dog park, and a one-bedroom, one-bath apartment tour.</p><p>As you click through, notice the details that are easiest to appreciate in motion: natural light in the fitness center, poolside seating and shaded areas, open outdoor space for pets, and an apartment layout with wood-look flooring, a breakfast bar, stainless steel appliances, and a comfortable bedroom retreat. When you’re ready to compare the tour with current options, explore <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> in Bedford.</p>",
  "property_copyright": "2025 All Rights Reserved. The Logan",
  "property_seo_title_home": "The Logan |  Apartments in Bedford, TX",
  "property_seo_description_home": "Discover modern living at The Logan in Bedford, TX! Choose from spacious one and two-bedroom homes with luxury amenities, including a pool and pet area.",
  "property_seo_title_floorplans": "Floor Plans | Bedford, TX Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal living space at The Logan in Bedford, TX. Choose from stylish one or two-bedroom options tailored to your lifestyle. Browse and discover today!",
  "property_seo_title_amenities": "Amenities | Bedford, TX Apartments for Rent",
  "property_seo_description_amenities": "Discover luxury at The Logan in Bedford, TX! Enjoy top amenities, including a pool, fitness center, and pet-friendly spaces. Join our vibrant community!",
  "property_seo_title_gallery": "Gallery | Apartments in Bedford, TX",
  "property_seo_description_gallery": "Experience luxury living at The Logan in Bedford, TX! Enjoy stunning amenities from a pool to a pet play area—picture your new life with us!",
  "property_seo_title_virtualtours": "Virtual Tours | The Logan Apartments",
  "property_seo_description_virtualtours": "Step inside The Logan in Bedford, TX! Experience comfort and style with our one and two-bedroom apartments. Take a virtual tour today and find your next home!",
  "property_seo_title_interactivemap": "Interactive Map | The Logan Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at The Logan in Bedford, TX! Explore our amenities and use our interactive map to discover available one and two-bedroom apartments.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Bedford, TX",
  "property_seo_description_neighborhood": "Uncover the gems of Bedford, TX! At The Logan, embrace vibrant living with nearby local favorites and essentials just steps from your one or two-bedroom haven.",
  "property_seo_title_contact": "Contact Us | The Logan",
  "property_seo_description_contact": "At The Logan in Bedford, TX, find your perfect one or two-bedroom haven. Have questions? Our friendly leasing team is ready to help—reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Bedford, TX",
  "property_seo_description_faqs": "Unlock the answers to your questions at The Logan in Bedford, TX. Discover our amenities, floor plans, and everything you need for a vibrant community life!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Bedford, TX",
  "property_seo_description_reviews": "Experience life at The Logan! Dive into resident reviews and see why our Bedford, TX community is the perfect blend of comfort, style, and convenience.",
  "property_seo_title_applynow": "Apply Now | Apartments in Bedford, TX",
  "property_seo_description_applynow": "Experience modern living at The Logan in Bedford, TX! Enjoy spacious one and two-bedroom homes with top-notch amenities. Your new home awaits—apply now!",
  "property_seo_title_residentaccess": "Resident Access | The Logan",
  "property_seo_description_residentaccess": "Unlock convenience at The Logan in Bedford, TX! Access your resident portal for secure rent payments, maintenance requests, and community updates—all in one place!",
  "property_seo_title_referafriend": "Refer A Friend | The Logan",
  "property_seo_description_referafriend": "Refer a friend to The Logan in Bedford, TX! Great friends make great neighbors—share the love of community and enjoy exclusive rewards together.",
  "property_seo_title_scheduletour": "Schedule a Tour | The Logan",
  "property_seo_description_scheduletour": "Experience the charm of The Logan in Bedford, TX. Schedule a tour today and envision your new life surrounded by vibrant community and modern comforts!",
  "property_seo_title_privacy": "Privacy Policy | The Logan",
  "property_seo_description_privacy": "At The Logan in Bedford, TX, your privacy is our priority. Learn how we protect your information with our comprehensive privacy policy. Your peace of mind awaits!",
  "property_seo_title_accessibility": "Website Accessibility | The Logan",
  "property_seo_description_accessibility": "At The Logan in Bedford, TX, we prioritize digital inclusion and accessibility for all. Join us in creating a community where everyone can thrive.",
  "property_seo_title_sitemap": "Sitemap | The Logan",
  "property_seo_description_sitemap": "Navigate through The Logan in Bedford, TX! Explore our sitemap for a seamless journey to find your dream apartment. Your ideal home awaits!",
  "property_seo_title_thankyou": "Thank You | The Logan",
  "property_seo_description_thankyou": "Thank you for reaching out to The Logan in Bedford, TX! Our team is excited to connect with you soon about your future home. Stay tuned for updates!",
  "property_seo_title_pets": "Pet Policy | Apartments in Austell, GA\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234320905",
  "amenities": [
    {
      "id": "custom_6ae51c26-359b-439a-8434-6fdc95efcf18",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Wood Style Flooring*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0289dd0d-4526-4981-a520-510d9c72a083",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9b7ecf72-31be-450d-9dd7-520b9b719dde",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Patios and Balconies",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_67808e84-3e98-46d6-8015-07dc13640a7c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fec0a28a-4432-41e1-978b-0cfb0e92f42e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "custom",
      "external_id": "P000000686",
      "title": "Stairs",
      "amount": "0.0000",
      "description": "Spiral Staircases*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e0b3397e-6f52-429e-a9fc-b0bd3380efe3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "custom",
      "external_id": "P000000690",
      "title": "Tall Ceilings",
      "amount": "0.0000",
      "description": "Vaulted Ceilings*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_395c9037-792d-45b1-942c-0352bbe5ca23",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "custom",
      "external_id": "P000000603",
      "title": "Blinds",
      "amount": "0.0000",
      "description": "Two Inch Plantation Style Blinds",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9e2ae318-f128-41a9-8d95-3f4d4330c4ef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "custom",
      "external_id": "P000000609",
      "title": "Cabinets",
      "amount": "0.0000",
      "description": "Designer Cabinetry",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e7605096-1496-4194-a7c7-740931e27932",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "custom",
      "external_id": "P000000613",
      "title": "Chef`s Kitchen",
      "amount": "0.0000",
      "description": "Gourmet Kitchens with Custom Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7e888534-e9f4-4ce2-9120-a3bff5f8a115",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "custom",
      "external_id": "P000000631",
      "title": "Fan",
      "amount": "0.0000",
      "description": "Ceiling Fans*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cde0a5c8-587d-4f22-89ba-9d8fba071dbf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "custom",
      "external_id": "P000000633",
      "title": "Fire",
      "amount": "0.0000",
      "description": "Fireplaces*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4a767607-b4eb-49f9-a1ea-ba924dec682c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "custom",
      "external_id": "P000002480",
      "title": "Swimming Pool",
      "amount": "0.0000",
      "description": "Two Swimming Pools",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c3d371e1-b728-4924-8135-e0e3cff35d3b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Modern Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d28e6ce0-6f39-4fd0-b49c-79175d4688a3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Bark Park for your Furry Friends",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a4c6eaee-a24e-4fc3-8404-c130c225ddb6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "custom",
      "external_id": "P000000644",
      "title": "Grill Area",
      "amount": "0.0000",
      "description": "Community Grilling Areas",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_74e1ac86-9cc5-492e-a733-1fbefa7146d9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "custom",
      "external_id": "P000000692",
      "title": "Tennis Court",
      "amount": "0.0000",
      "description": "Tennis Court",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_86d976f9-d16b-426e-9575-4a4a0cdb274a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "custom",
      "external_id": "P000002472",
      "title": "Pet Spa",
      "amount": "0.0000",
      "description": "Pet Spa",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_74398862-4de1-452a-b7e5-1a21d5b57403",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "custom",
      "external_id": "P000000145",
      "title": "LUXER Package Locker",
      "amount": "0.0000",
      "description": "Package Lockers",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c766f84e-21a6-41ed-8b12-2180176d74ae",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cd57becf-58ab-4f2b-9d6d-75a80dc5a8a4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_75d1d985-ddc1-4cbd-8fea-398c1fb2d66d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019e8a01-88a1-702d-b4b9-76c77a0e9b69.webp",
      "image_media": {
        "alt_text": "Bedroom with a white bed, black nightstands, and a window with gray curtains.",
        "public_id": "019e8a01-88a1-702d-b4b9-76c77a0e9b69",
        "storage_key": "property/5767160559304704/019e8a01-88a1-702d-b4b9-76c77a0e9b69.webp",
        "width": 3024,
        "height": 2012
      },
      "title": "Apartment",
      "description": "Cozy and modern bedroom featuring a comfortable white bed with coral accents, elegant nightstands, and ample natural light from the window.",
      "link": "",
      "alt_text": "Bedroom with a white bed, black nightstands, and a window with gray curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_37448c8a-8f82-4ec2-a810-e70c22af74fb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019e8a01-88d5-75c6-8fa2-10fc552916b9.webp",
      "image_media": {
        "alt_text": "Modern living room with a sofa, armchairs, coffee table, and bar stools.",
        "public_id": "019e8a01-88d5-75c6-8fa2-10fc552916b9",
        "storage_key": "property/5767160559304704/019e8a01-88d5-75c6-8fa2-10fc552916b9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish living area featuring a comfortable sofa, accent armchairs, a sleek coffee table, and a breakfast bar with stools, perfect for entertaining.",
      "link": "",
      "alt_text": "Modern living room with a sofa, armchairs, coffee table, and bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f9f57e1c-4226-4cd0-bda9-b806d42211b9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019e8a01-89c5-756a-9cf3-1d198737b8ca.webp",
      "image_media": {
        "alt_text": "Blue tennis court with white lines and a net, surrounded by a fence, with apartment buildings in the background.",
        "public_id": "019e8a01-89c5-756a-9cf3-1d198737b8ca",
        "storage_key": "property/5767160559304704/019e8a01-89c5-756a-9cf3-1d198737b8ca.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a friendly match on our vibrant blue tennis court, a perfect amenity for staying active and having fun right here at home.",
      "link": "",
      "alt_text": "Blue tennis court with white lines and a net, surrounded by a fence, with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dc472fc6-528f-453a-9632-4de46bc97ed1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019e8a01-880b-760b-9473-49003299eb6d.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, stationary bikes, weight machines, and a bench.",
        "public_id": "019e8a01-880b-760b-9473-49003299eb6d",
        "storage_key": "property/5767160559304704/019e8a01-880b-760b-9473-49003299eb6d.webp",
        "width": 1671,
        "height": 1114
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines and strength training equipment for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with treadmills, stationary bikes, weight machines, and a bench.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2e916cbd-41f8-42bd-891b-823d3515bd97",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019e8a01-70a6-7262-a56b-a8fb0a9e3656.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with lush green lawn and walking path",
        "public_id": "019e8a01-70a6-7262-a56b-a8fb0a9e3656",
        "storage_key": "property/5767160559304704/019e8a01-70a6-7262-a56b-a8fb0a9e3656.webp",
        "width": 3015,
        "height": 2006
      },
      "title": "Community",
      "description": "Exterior view of a brick apartment building surrounded by a well-maintained lawn and a winding pathway, showcasing the community's serene environment.",
      "link": "",
      "alt_text": "Apartment building exterior with lush green lawn and walking path",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_96f638a9-f603-4a5c-883e-66044b0af120",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019e8a01-70b5-72f8-9c90-f901bfec5008.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and surrounding apartment buildings.",
        "public_id": "019e8a01-70b5-72f8-9c90-f901bfec5008",
        "storage_key": "property/5767160559304704/019e8a01-70b5-72f8-9c90-f901bfec5008.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling resort-style pool, perfect for relaxing on sunny days. Lounge chairs available for your comfort.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and surrounding apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_82a5871f-ee75-43c9-b9af-1cf436927e55",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019e8a01-70a4-72aa-93af-f86a653a2e44.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and hot tub with lounge chairs and apartment buildings in the background.",
        "public_id": "019e8a01-70a4-72aa-93af-f86a653a2e44",
        "storage_key": "property/5767160559304704/019e8a01-70a4-72aa-93af-f86a653a2e44.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind by our beautiful outdoor swimming pool and spa. Perfect for soaking up the sun or enjoying a refreshing dip.",
      "link": "",
      "alt_text": "Outdoor swimming pool and hot tub with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_870c8ebf-2cf2-4aa6-9cc1-6f9162753f84",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019e8a01-6fd2-713a-be61-8a2dc58a5adb.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and subway tile backsplash.",
        "public_id": "019e8a01-6fd2-713a-be61-8a2dc58a5adb",
        "storage_key": "property/5767160559304704/019e8a01-6fd2-713a-be61-8a2dc58a5adb.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Discover a beautifully appointed kitchen featuring sleek stainless steel appliances, elegant granite countertops, and a classic subway tile backsplash. Perfect for preparing your favorite meals.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and subway tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bc430ef1-e088-4fd1-a44d-d28aa9fb2eeb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019e8a01-6eac-709b-93fe-07cc872a45fd.webp",
      "image_media": {
        "alt_text": "Fitness center with multiple weight machines, rowing machine, and weight racks.",
        "public_id": "019e8a01-6eac-709b-93fe-07cc872a45fd",
        "storage_key": "property/5767160559304704/019e8a01-6eac-709b-93fe-07cc872a45fd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active and energized in our fully-equipped fitness center, featuring state-of-the-art weight machines and cardio equipment.",
      "link": "",
      "alt_text": "Fitness center with multiple weight machines, rowing machine, and weight racks.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_13c2fb7a-effd-402b-91eb-8268299f137e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019e8a01-708a-720e-8d3d-31346c48511b.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and seating areas.",
        "public_id": "019e8a01-708a-720e-8d3d-31346c48511b",
        "storage_key": "property/5767160559304704/019e8a01-708a-720e-8d3d-31346c48511b.webp",
        "width": 2981,
        "height": 1984
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and stylish seating areas perfect for relaxing.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and seating areas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d16b26da-26e0-4d6f-9727-76412ded53b0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019e8a01-7082-7778-ae7f-e2799281ccd0.webp",
      "image_media": {
        "alt_text": "Dog park agility equipment with benches and apartment buildings in background.",
        "public_id": "019e8a01-7082-7778-ae7f-e2799281ccd0",
        "storage_key": "property/5767160559304704/019e8a01-7082-7778-ae7f-e2799281ccd0.webp",
        "width": 2412,
        "height": 1605
      },
      "title": "Community",
      "description": "Spacious dog park featuring agility equipment for pets to play and exercise, surrounded by lush green grass and trees, with apartment buildings visible in the distance.",
      "link": "",
      "alt_text": "Dog park agility equipment with benches and apartment buildings in background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c38d2130-d386-4ca3-93cf-c5387b372994",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019e8a01-6f97-73bb-8c3a-0c1293bdc847.webp",
      "image_media": {
        "alt_text": "Kitchen with granite countertops, sink, and dishwasher.",
        "public_id": "019e8a01-6f97-73bb-8c3a-0c1293bdc847",
        "storage_key": "property/5767160559304704/019e8a01-6f97-73bb-8c3a-0c1293bdc847.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring granite countertops, a stainless steel sink, and a dishwasher, with a view into the living area.",
      "link": "",
      "alt_text": "Kitchen with granite countertops, sink, and dishwasher.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c953f0d8-b320-4ff9-aa9e-db398f370b69",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019e8a01-70fb-75d3-88e4-c4b8551cd29e.webp",
      "image_media": {
        "alt_text": "Living room with gray sofa, orange chairs, and a coffee table.",
        "public_id": "019e8a01-70fb-75d3-88e4-c4b8551cd29e",
        "storage_key": "property/5767160559304704/019e8a01-70fb-75d3-88e4-c4b8551cd29e.webp",
        "width": 2420,
        "height": 1610
      },
      "title": "Apartment",
      "description": "Stylish living room with comfortable seating, a modern coffee table, and vibrant decor. Perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with gray sofa, orange chairs, and a coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a370c8c4-559a-4c63-a253-9f41208f91fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019e8a01-7281-751b-a10e-a44067cfe26b.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, sink, toilet, and shower with striped curtains.",
        "public_id": "019e8a01-7281-751b-a10e-a44067cfe26b",
        "storage_key": "property/5767160559304704/019e8a01-7281-751b-a10e-a44067cfe26b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax and unwind in this beautifully appointed apartment bathroom, featuring a modern vanity, sink, and a private shower area.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, sink, toilet, and shower with striped curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_2e0ab495cc0579a09ffaed9e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Coffee Tea & Books",
      "poi_type": "Restaurants",
      "poi_address": "2813 Central Dr, Bedford, TX 76021, USA",
      "poi_short_description": "Cozy, book-friendly coffee shop with pastries, tea, and a selection of board games.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-8d07-753f-b9c6-9247d3175613.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-8d07-753f-b9c6-9247d3175613",
        "storage_key": "property/5767160559304704/019f14ea-8d07-753f-b9c6-9247d3175613.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://coffeeteaandbooks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9647739746328628929&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "coffee-tea--books",
      "poi_latitude": "32.850103",
      "poi_longitude": "-97.1326987",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-940-3646",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-e897-75e7-8077-3f877a1dedf7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-e897-75e7-8077-3f877a1dedf7",
        "storage_key": "property/5767160559304704/019f14ea-e897-75e7-8077-3f877a1dedf7.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJtXfjQMl_ToYRwc5V8S6o44U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_f24434632595237efea52aa1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Twisted Root Burger Co.",
      "poi_type": "Restaurants",
      "poi_address": "2820 Central Dr, Bedford, TX 76021, USA",
      "poi_short_description": "Gourmet burger chain with beef, turkey & vegan options (some offer game meats), plus spiked shakes.",
      "poi_long_description": "Gourmet burger chain with beef, turkey & vegan options (some offer game meats), plus spiked shakes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-87b1-7745-a599-e6154ef05f96.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-87b1-7745-a599-e6154ef05f96",
        "storage_key": "property/5767160559304704/019f14ea-87b1-7745-a599-e6154ef05f96.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.twistedrootburgerco.com/locations/bedford",
      "poi_directions_map_url": "https://maps.google.com/?cid=1441156698971658199&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "twisted-root-burger-co",
      "poi_latitude": "32.8514302",
      "poi_longitude": "-97.1313317",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 682-444-5650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-25b9-7298-81f8-d0c9239978a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-25b9-7298-81f8-d0c9239978a4",
        "storage_key": "property/5767160559304704/019d02f5-25b9-7298-81f8-d0c9239978a4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCTPCk6F_ToYR11fh02EEABQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "ec_2c9039e25358defe108bd55c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Bleu Bear Sushi, Bedford, TX",
      "poi_type": "Restaurants",
      "poi_address": "2807 Central Dr, Bedford, TX 76021, USA",
      "poi_short_description": "Relaxed restaurant specializing in sushi in a variety of rolls (including signature ones).",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-8dc6-72bb-a972-01473efd8e7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-8dc6-72bb-a972-01473efd8e7a",
        "storage_key": "property/5767160559304704/019f14ea-8dc6-72bb-a972-01473efd8e7a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bleubearsushi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8003033122951115561&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bleu-bear-sushi-bedford-tx",
      "poi_latitude": "32.8500457",
      "poi_longitude": "-97.1325515",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 682-503-6312",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-25b9-7298-81f8-d0c9239978a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-25b9-7298-81f8-d0c9239978a4",
        "storage_key": "property/5767160559304704/019d02f5-25b9-7298-81f8-d0c9239978a4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhyD0czp_ToYRKbMvMzl8EG8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "ec_09b271c9b7682bda49caf99c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Holey Boba & Donuts",
      "poi_type": "Restaurants",
      "poi_address": "2816 Central Dr, Bedford, TX 76021, USA",
      "poi_short_description": "Fun, tidy cafe featuring freshly prepared donuts as well as breakfast sandwiches, iced coffees and boba tea.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-8a3d-742a-9d89-afe45277523a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-8a3d-742a-9d89-afe45277523a",
        "storage_key": "property/5767160559304704/019f14ea-8a3d-742a-9d89-afe45277523a.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15649586405998039583&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "holey-boba--donuts",
      "poi_latitude": "32.85165",
      "poi_longitude": "-97.1298111",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-494-3839",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-25b9-7298-81f8-d0c9239978a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-25b9-7298-81f8-d0c9239978a4",
        "storage_key": "property/5767160559304704/019d02f5-25b9-7298-81f8-d0c9239978a4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJE9yjPKJ_ToYRH5JL0-t_Ltk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "donut_shop"
    },
    {
      "id": "ec_87d2b4c8dc97bd18ca23df8a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "The Hub Restaurant and Bar",
      "poi_type": "Restaurants",
      "poi_address": "2208 Central Dr, Bedford, TX 76021, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-897f-72d9-8c1b-70fbe45b74ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-897f-72d9-8c1b-70fbe45b74ee",
        "storage_key": "property/5767160559304704/019f14ea-897f-72d9-8c1b-70fbe45b74ee.webp",
        "width": 1161,
        "height": 1280
      },
      "poi_business_url": "https://www.thehubbedford.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18103898677633219474&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-hub-restaurant-and-bar",
      "poi_latitude": "32.8421491",
      "poi_longitude": "-97.1327713",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 682-738-3007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-25b9-7298-81f8-d0c9239978a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-25b9-7298-81f8-d0c9239978a4",
        "storage_key": "property/5767160559304704/019d02f5-25b9-7298-81f8-d0c9239978a4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtwl-kCx_ToYRkvv9we33Pfs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_d70076495792e45dd3a18060",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Saltgrass Steak House",
      "poi_type": "Restaurants",
      "poi_address": "1813 State Hwy 121, Bedford, TX 76021, USA",
      "poi_short_description": "Informal Texas-themed chain offers a meaty menu & full bar amid cattle kitsch decor.",
      "poi_long_description": "Informal Texas-themed chain offers a meaty menu & full bar amid cattle kitsch decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-8866-70f8-a65e-96baf234dda8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-8866-70f8-a65e-96baf234dda8",
        "storage_key": "property/5767160559304704/019f14ea-8866-70f8-a65e-96baf234dda8.webp",
        "width": 1069,
        "height": 1280
      },
      "poi_business_url": "https://www.saltgrass.com/location/saltgrass-bedford/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9237560198146909586&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saltgrass-steak-house",
      "poi_latitude": "32.8399506",
      "poi_longitude": "-97.1217911",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-864-9561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-25b9-7298-81f8-d0c9239978a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-25b9-7298-81f8-d0c9239978a4",
        "storage_key": "property/5767160559304704/019d02f5-25b9-7298-81f8-d0c9239978a4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUVcdSkh_ToYRkmXVuQ5oMoA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "ec_56aa0eaa9a2fcffd711e06af",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "3000 Crystal Spgs St, Bedford, TX 76021, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14e9-06dc-7389-af0a-db5f2a82656b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-06dc-7389-af0a-db5f2a82656b",
        "storage_key": "property/5767160559304704/019f14e9-06dc-7389-af0a-db5f2a82656b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/texas/bedford?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=237415625565201674&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "32.8540146",
      "poi_longitude": "-97.1105924",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-858-0427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-25b9-7298-81f8-d0c9239978a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-25b9-7298-81f8-d0c9239978a4",
        "storage_key": "property/5767160559304704/019d02f5-25b9-7298-81f8-d0c9239978a4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJO78m0cF_ToYRCuXw6UB4SwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "ec_772be33bd0e8fdbe2fa93a52",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Spring Creek Barbeque",
      "poi_type": "Restaurants",
      "poi_address": "1509 Airport Fwy, Bedford, TX 76021, USA",
      "poi_short_description": "Branch of a Texas smokehouse chain dishing up meat & sides in a simple, family-friendly setting.",
      "poi_long_description": "Branch of a Texas smokehouse chain dishing up meat & sides in a simple, family-friendly setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-8d7d-77ce-a633-b252b2600990.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-8d7d-77ce-a633-b252b2600990",
        "storage_key": "property/5767160559304704/019f14ea-8d7d-77ce-a633-b252b2600990.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.springcreekbarbeque.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9756151344335539941&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spring-creek-barbeque",
      "poi_latitude": "32.8376712",
      "poi_longitude": "-97.1424158",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-545-0184",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-25b9-7298-81f8-d0c9239978a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-25b9-7298-81f8-d0c9239978a4",
        "storage_key": "property/5767160559304704/019d02f5-25b9-7298-81f8-d0c9239978a4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJy9feOwR_ToYR5c4RFvXPZIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_b3428c54cb8e43a023f31e41",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Jason's Deli",
      "poi_type": "Restaurants",
      "poi_address": "2200 Airport Fwy, Bedford, TX 76022, USA",
      "poi_short_description": "Deli chain featuring specialty sandwiches, salads & other health-conscious fare.",
      "poi_long_description": "Deli chain featuring specialty sandwiches, salads & other health-conscious fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-87ba-70fd-9ff6-449c8db9bc6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-87ba-70fd-9ff6-449c8db9bc6e",
        "storage_key": "property/5767160559304704/019f14ea-87ba-70fd-9ff6-449c8db9bc6e.webp",
        "width": 1280,
        "height": 724
      },
      "poi_business_url": "https://www.jasonsdeli.com/locations/tx/bedford/2200-airport-fwy/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4700446510122688327&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jasons-deli",
      "poi_latitude": "32.835071",
      "poi_longitude": "-97.1322937",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-354-1511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-25b9-7298-81f8-d0c9239978a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-25b9-7298-81f8-d0c9239978a4",
        "storage_key": "property/5767160559304704/019d02f5-25b9-7298-81f8-d0c9239978a4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMRtG7qt_ToYRR1-WaTJXO0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_99d9c903314e71ef6dcf6c82",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Prestige Cigars Lounge & Coffee Bar",
      "poi_type": "Restaurants",
      "poi_address": "3225 Harwood Rd Ste E, Bedford, TX 76021, USA",
      "poi_short_description": "Tobacconist with a walk-in humidor & smoke lounge, plus stogies, shisha & novelty pipes.",
      "poi_long_description": "Tobacconist with a walk-in humidor & smoke lounge, plus stogies, shisha & novelty pipes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-8c99-718a-bd44-3379e1c775f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-8c99-718a-bd44-3379e1c775f9",
        "storage_key": "property/5767160559304704/019f14ea-8c99-718a-bd44-3379e1c775f9.webp",
        "width": 756,
        "height": 757
      },
      "poi_business_url": "https://prestigecigarlounge.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14054052606868877718&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prestige-cigars-lounge--coffee-bar",
      "poi_latitude": "32.8524878",
      "poi_longitude": "-97.1154552",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 817-600-0317",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-25ba-756c-94c7-39c181deca50.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-25ba-756c-94c7-39c181deca50",
        "storage_key": "property/5767160559304704/019d02f5-25ba-756c-94c7-39c181deca50.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJn6Shlr9_ToYRlnESZ2IGCsM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "ec_2e2fa7ae0f4b8ac62b1b12ae",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Green Nest Cafe",
      "poi_type": "Restaurants",
      "poi_address": "3708 Cheek-Sparger Rd #110, Bedford, TX 76021, USA",
      "poi_short_description": "Casual, cozy, trendy eatery for hot coffee, iced brews and lattes, plus salads and sandwiches, with breakfast options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-9274-7712-aa32-31255d05dc33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-9274-7712-aa32-31255d05dc33",
        "storage_key": "property/5767160559304704/019f14ea-9274-7712-aa32-31255d05dc33.webp",
        "width": 989,
        "height": 1280
      },
      "poi_business_url": "https://www.instagram.com/greennestcafe",
      "poi_directions_map_url": "https://maps.google.com/?cid=11768131323649745478&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "green-nest-cafe",
      "poi_latitude": "32.86494640000001",
      "poi_longitude": "-97.1075499",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 817-701-7993",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-e897-75e7-8077-3f877a1dedf7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-e897-75e7-8077-3f877a1dedf7",
        "storage_key": "property/5767160559304704/019f14ea-e897-75e7-8077-3f877a1dedf7.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJXaCJZ3p_ToYRRmJKsBbNUKM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_2abbd503ef054119d0bdc74b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "El Pollo Loco",
      "poi_type": "Restaurants",
      "poi_address": "1900 Central Dr, Bedford, TX 76021, USA",
      "poi_short_description": "Fast-food chain outpost known for Mexican classics made with fire-grilled chicken.",
      "poi_long_description": "Fast-food chain outpost known for Mexican classics made with fire-grilled chicken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-8eff-77e5-946b-d09c675413a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-8eff-77e5-946b-d09c675413a4",
        "storage_key": "property/5767160559304704/019f14ea-8eff-77e5-946b-d09c675413a4.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://restaurants.elpolloloco.com/tx/bedford/1900-central-dr?utm_source=gmb&utm_medium=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=16699546074864327714&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-pollo-loco",
      "poi_latitude": "32.8385445",
      "poi_longitude": "-97.1329104",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-684-9020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-25b9-7298-81f8-d0c9239978a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-25b9-7298-81f8-d0c9239978a4",
        "storage_key": "property/5767160559304704/019d02f5-25b9-7298-81f8-d0c9239978a4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKXbzBal_ToYRIpyOVq20wOc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_cdc9e527981bd5dc3b8f7fd6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Tony's Pizza and Pasta",
      "poi_type": "Restaurants",
      "poi_address": "3320 Harwood Rd, Bedford, TX 76021, USA",
      "poi_short_description": "BYOB pizzeria dishing casual Italian fare, including a range of pizzas by the slice or pie.",
      "poi_long_description": "BYOB pizzeria dishing casual Italian fare, including a range of pizzas by the slice or pie.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-91c8-73e1-a5c7-784139ce3647.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-91c8-73e1-a5c7-784139ce3647",
        "storage_key": "property/5767160559304704/019f14ea-91c8-73e1-a5c7-784139ce3647.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://tonyspizzaandpasta.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=110135918407879217&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tonys-pizza-and-pasta",
      "poi_latitude": "32.8506653",
      "poi_longitude": "-97.1134165",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-354-8899",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-25b9-7298-81f8-d0c9239978a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-25b9-7298-81f8-d0c9239978a4",
        "storage_key": "property/5767160559304704/019d02f5-25b9-7298-81f8-d0c9239978a4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ45xN74t_ToYRMYq2xQhIhwE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_469e3ff012f2fb38a8843ef3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Turning Point Beer",
      "poi_type": "Restaurants",
      "poi_address": "1307 Brown Trail, Bedford, TX 76022, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-93c5-760c-9a11-56e322101e17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-93c5-760c-9a11-56e322101e17",
        "storage_key": "property/5767160559304704/019f14ea-93c5-760c-9a11-56e322101e17.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.turningpointbeer.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18031806902892530502&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "turning-point-beer",
      "poi_latitude": "32.8351537",
      "poi_longitude": "-97.1626542",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-705-8817",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-2a7e-72da-95d6-f8b8dae6b23b",
        "storage_key": "property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFXBq_CN_ToYRRotYcdfYPfo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "ec_16510ff4d8efaab889679f66",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Saltgrass Steak House",
      "poi_type": "Restaurants",
      "poi_address": "1813 State Hwy 121, Bedford, TX 76021, USA",
      "poi_short_description": "Informal Texas-themed chain offers a meaty menu & full bar amid cattle kitsch decor.",
      "poi_long_description": "Informal Texas-themed chain offers a meaty menu & full bar amid cattle kitsch decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-92e9-756e-9477-486b419cfc52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-92e9-756e-9477-486b419cfc52",
        "storage_key": "property/5767160559304704/019f14ea-92e9-756e-9477-486b419cfc52.webp",
        "width": 1069,
        "height": 1280
      },
      "poi_business_url": "https://www.saltgrass.com/location/saltgrass-bedford/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9237560198146909586&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saltgrass-steak-house",
      "poi_latitude": "32.8399506",
      "poi_longitude": "-97.1217911",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-864-9561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-25b9-7298-81f8-d0c9239978a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-25b9-7298-81f8-d0c9239978a4",
        "storage_key": "property/5767160559304704/019d02f5-25b9-7298-81f8-d0c9239978a4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUVcdSkh_ToYRkmXVuQ5oMoA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "ec_4fba1a4bce42255143bbd5f2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "2108 Bedford Rd, Bedford, TX 76021, USA",
      "poi_short_description": "Chain supermarket offering groceries, electronics, furniture, appliances, and other merchandise, plus check cashing.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-9674-7494-aaec-61043a6bd507.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-9674-7494-aaec-61043a6bd507",
        "storage_key": "property/5767160559304704/019f14ea-9674-7494-aaec-61043a6bd507.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walmart.com/store/3392-bedford-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=9243868335846487013&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "32.8436418",
      "poi_longitude": "-97.1322989",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-283-9841",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-25be-73fa-a7f6-f5fbf999b7e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-25be-73fa-a7f6-f5fbf999b7e3",
        "storage_key": "property/5767160559304704/019d02f5-25be-73fa-a7f6-f5fbf999b7e3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw5OJCqd_ToYR5XOcfEbRSIA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_2adb6d3fd4c8f8b726d67810",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "2109 Harwood Rd, Bedford, TX 76021, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-967f-715c-8a62-c599ab6594c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-967f-715c-8a62-c599ab6594c4",
        "storage_key": "property/5767160559304704/019f14ea-967f-715c-8a62-c599ab6594c4.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/tx/bedford/bedford/035/00521?cid=loc_03500521_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=3896871285611125210&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "32.8535757",
      "poi_longitude": "-97.1332035",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-685-9266",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-25be-73fa-a7f6-f5fbf999b7e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-25be-73fa-a7f6-f5fbf999b7e3",
        "storage_key": "property/5767160559304704/019d02f5-25be-73fa-a7f6-f5fbf999b7e3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0fU2PKB_ToYR2llFqsl3FDY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_3ede1874af642df682070a3d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Tom Thumb",
      "poi_type": "Shopping & Retail",
      "poi_address": "4000 Glade Rd, Colleyville, TX 76034, USA",
      "poi_short_description": "Chain market with a deli and bakery section that specializes in made-to-order cakes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-9873-762c-8c23-3d6f7518fc95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-9873-762c-8c23-3d6f7518fc95",
        "storage_key": "property/5767160559304704/019f14ea-9873-762c-8c23-3d6f7518fc95.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://local.tomthumb.com/tx/colleyville/4000-glade-rd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=16218556263347161405&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tom-thumb",
      "poi_latitude": "32.8825907",
      "poi_longitude": "-97.1013697",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-354-0505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-25be-73fa-a7f6-f5fbf999b7e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-25be-73fa-a7f6-f5fbf999b7e3",
        "storage_key": "property/5767160559304704/019d02f5-25be-73fa-a7f6-f5fbf999b7e3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLyMiJlfVTYYRPYl-7v3iE-E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_27cb12f4d4750630ea2ecea6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "4101 Hwy 121, Bedford, TX 76021, USA",
      "poi_short_description": "Department, grocery and electronics store with self-service checkout stations and a friendly staff.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-97fa-7446-9b91-0040ba2476b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-97fa-7446-9b91-0040ba2476b4",
        "storage_key": "property/5767160559304704/019f14ea-97fa-7446-9b91-0040ba2476b4.webp",
        "width": 1000,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1178-bedford-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=5357944823677464364&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "32.8642021",
      "poi_longitude": "-97.1059941",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-571-7929",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-25ba-756c-94c7-39c181deca50.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-25ba-756c-94c7-39c181deca50",
        "storage_key": "property/5767160559304704/019d02f5-25ba-756c-94c7-39c181deca50.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJMVgPu-9_ToYRLC9w9W0-W0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_e044ff9fa57890f64cc0840e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "2900 Central Dr, Bedford, TX 76021, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-9680-76b9-981a-60d54e87e596.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-9680-76b9-981a-60d54e87e596",
        "storage_key": "property/5767160559304704/019f14ea-9680-76b9-981a-60d54e87e596.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/bedford-tx-pharmacies/2900-central-dr-bedford-tx-76021/storeid=7449?WT.mc_id=LS_GOOGLE_RX_7449",
      "poi_directions_map_url": "https://maps.google.com/?cid=14103719006248815440&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "32.8524047",
      "poi_longitude": "-97.1315133",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-571-7979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-e896-750a-b4a4-ed22ad087cc6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-e896-750a-b4a4-ed22ad087cc6",
        "storage_key": "property/5767160559304704/019f14ea-e896-750a-b4a4-ed22ad087cc6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNUWB5aF_ToYRUMtiI7Z5usM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_b7433d1f6e41663f1e618aef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "QuikTrip",
      "poi_type": "Shopping & Retail",
      "poi_address": "2201 Central Dr, Bedford, TX 76021, USA",
      "poi_short_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_long_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-96c3-7539-9e7a-6acd24d5e24d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-96c3-7539-9e7a-6acd24d5e24d",
        "storage_key": "property/5767160559304704/019f14ea-96c3-7539-9e7a-6acd24d5e24d.webp",
        "width": 600,
        "height": 339
      },
      "poi_business_url": "https://locations.quiktrip.com/tx/bedford/2201-central-dr?utm_source=gmb&utm_medium=yext&y_source=1_MTYwMDQ1MTktNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6551659232165092394&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quiktrip",
      "poi_latitude": "32.8416463",
      "poi_longitude": "-97.1342799",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-358-8882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-e897-75e7-8077-40a9d627321e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-e897-75e7-8077-40a9d627321e",
        "storage_key": "property/5767160559304704/019f14ea-e897-75e7-8077-40a9d627321e.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJiRLZdqh_ToYRKtybBlwr7Fo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "ec_d0c1fb58b96293d84aea120a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "4121 Harwood Rd, Bedford, TX 76021, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-9a00-7239-bd5e-a76589decc31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-9a00-7239-bd5e-a76589decc31",
        "storage_key": "property/5767160559304704/019f14ea-9a00-7239-bd5e-a76589decc31.webp",
        "width": 1280,
        "height": 816
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-4121+harwood+rd-bedford-tx-76021/id=7299",
      "poi_directions_map_url": "https://maps.google.com/?cid=9145541889352351755&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "32.8524471",
      "poi_longitude": "-97.1006633",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-571-6995",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-2a7e-72da-95d6-f8b8dae6b23b",
        "storage_key": "property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc40mnMF_ToYRC0BNqeR9634",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_7d6aceb68a6d7d44e88d6471",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Petco",
      "poi_type": "Shopping & Retail",
      "poi_address": "2121 Harwood Rd, Bedford, TX 76021, USA",
      "poi_short_description": "Chain with pet food & supplies such as toys, beds & pet technology products, plus medication.",
      "poi_long_description": "Chain with pet food & supplies such as toys, beds & pet technology products, plus medication.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-9b11-75b8-8fef-eb401e3f479f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-9b11-75b8-8fef-eb401e3f479f",
        "storage_key": "property/5767160559304704/019f14ea-9b11-75b8-8fef-eb401e3f479f.webp",
        "width": 1280,
        "height": 1023
      },
      "poi_business_url": "https://stores.petco.com/tx/bedford/pet-supplies-bedford-tx-431.html?utm_source=google&utm_campaign=locallist_431_pcc",
      "poi_directions_map_url": "https://maps.google.com/?cid=6847398147373884682&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "petco",
      "poi_latitude": "32.85246960000001",
      "poi_longitude": "-97.1326398",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-571-9882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-25ba-756c-94c7-39c181deca50.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-25ba-756c-94c7-39c181deca50",
        "storage_key": "property/5767160559304704/019d02f5-25ba-756c-94c7-39c181deca50.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJNSD0O6B_ToYRCmXjAVbYBl8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pet_store"
    },
    {
      "id": "ec_7d3b7647532c4a7ddf752abe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Central Park",
      "poi_type": "Shopping & Retail",
      "poi_address": "1201 Central Dr, Bedford, TX 76022, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-9d7b-75d8-bc0b-53170b7ed0e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-9d7b-75d8-bc0b-53170b7ed0e2",
        "storage_key": "property/5767160559304704/019f14ea-9d7b-75d8-bc0b-53170b7ed0e2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bedfordtx.gov/797/Central-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16946138223623832225&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-park",
      "poi_latitude": "32.8308545",
      "poi_longitude": "-97.1341987",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-952-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-3002-7018-bf65-947751a8fef8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-3002-7018-bf65-947751a8fef8",
        "storage_key": "property/5767160559304704/019d02f5-3002-7018-bf65-947751a8fef8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_S4KBHl_ToYRoYLEDe7GLOs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_1d6e20f9b7a27d4c972296e0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "1400 Precinct Line Rd, Hurst, TX 76053, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-9cb6-71d8-9d2d-6ac2b81b5a7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-9cb6-71d8-9d2d-6ac2b81b5a7f",
        "storage_key": "property/5767160559304704/019f14ea-9cb6-71d8-9d2d-6ac2b81b5a7f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.target.com/sl/hurst/1766",
      "poi_directions_map_url": "https://maps.google.com/?cid=7949954304973420337&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "32.8366379",
      "poi_longitude": "-97.1834038",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-282-8808",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-25ba-756c-94c7-39c181deca50.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-25ba-756c-94c7-39c181deca50",
        "storage_key": "property/5767160559304704/019d02f5-25ba-756c-94c7-39c181deca50.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJi1KZLdJ4ToYRMTeH2FHpU24",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_5c907bc60aa80c2956e93c72",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Spring Garden Elementary",
      "poi_type": "Education",
      "poi_address": "2400 Cummings Dr, Bedford, TX 76021, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-9dca-72dd-8f11-23a1f52700d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-9dca-72dd-8f11-23a1f52700d8",
        "storage_key": "property/5767160559304704/019f14ea-9dca-72dd-8f11-23a1f52700d8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.hebisd.edu/SpringGarden",
      "poi_directions_map_url": "https://maps.google.com/?cid=3471782088197855008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spring-garden-elementary",
      "poi_latitude": "32.8586449",
      "poi_longitude": "-97.1280455",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 817-399-3320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-25bd-7650-b3e5-cf64de4e7e00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-25bd-7650-b3e5-cf64de4e7e00",
        "storage_key": "property/5767160559304704/019d02f5-25bd-7650-b3e5-cf64de4e7e00.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsZmc_Jt_ToYRINeYOGo_LjA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_30720ca2b2df4db98bda3613",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Bedford Heights Elementary",
      "poi_type": "Education",
      "poi_address": "1000 Cummings Dr N, Bedford, TX 76021, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-9cc6-732d-8fa7-192a97884f03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-9cc6-732d-8fa7-192a97884f03",
        "storage_key": "property/5767160559304704/019f14ea-9cc6-732d-8fa7-192a97884f03.webp",
        "width": 1280,
        "height": 676
      },
      "poi_business_url": "http://www.hebisd.edu/BedfordHeights",
      "poi_directions_map_url": "https://maps.google.com/?cid=7705840280967199383&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bedford-heights-elementary",
      "poi_latitude": "32.8607197",
      "poi_longitude": "-97.1500517",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 817-399-3010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-25bd-7650-b3e5-cf64de4e7e00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-25bd-7650-b3e5-cf64de4e7e00",
        "storage_key": "property/5767160559304704/019d02f5-25bd-7650-b3e5-cf64de4e7e00.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJla_6EG9_ToYRlzryguik8Go",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_78fd44091e4725ac23116627",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Meadow Creek Elementary",
      "poi_type": "Education",
      "poi_address": "3001 Harwood Rd, Bedford, TX 76021, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-9efd-7229-b4b2-32559909d3a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-9efd-7229-b4b2-32559909d3a2",
        "storage_key": "property/5767160559304704/019f14ea-9efd-7229-b4b2-32559909d3a2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.hebisd.edu/MeadowCreek",
      "poi_directions_map_url": "https://maps.google.com/?cid=14601658701928459716&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meadow-creek-elementary",
      "poi_latitude": "32.8529872",
      "poi_longitude": "-97.118242",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 817-399-3620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-25bd-7650-b3e5-cf64de4e7e00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-25bd-7650-b3e5-cf64de4e7e00",
        "storage_key": "property/5767160559304704/019d02f5-25bd-7650-b3e5-cf64de4e7e00.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrfcYF75_ToYRxO3v-zmDo8o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_838131648b192d369b8f36b4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Bell Manor Elementary School",
      "poi_type": "Education",
      "poi_address": "1300 Winchester Way, Bedford, TX 76022, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-9fc3-7438-8434-d8df3822c544.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-9fc3-7438-8434-d8df3822c544",
        "storage_key": "property/5767160559304704/019f14ea-9fc3-7438-8434-d8df3822c544.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.hebisd.edu/BellManor",
      "poi_directions_map_url": "https://maps.google.com/?cid=1420476535048378999&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bell-manor-elementary-school",
      "poi_latitude": "32.831352",
      "poi_longitude": "-97.136554",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-399-3466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-25bd-7650-b3e5-cf64de4e7e00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-25bd-7650-b3e5-cf64de4e7e00",
        "storage_key": "property/5767160559304704/019d02f5-25bd-7650-b3e5-cf64de4e7e00.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJl8gkGgB_ToYRdxpW8-GLthM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_4a2d7b543a3db7b5a523881f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Bedford Junior High School",
      "poi_type": "Education",
      "poi_address": "325 Carolyn Dr, Bedford, TX 76021, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-a15b-753f-b3d0-f1f76701c1ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-a15b-753f-b3d0-f1f76701c1ca",
        "storage_key": "property/5767160559304704/019f14ea-a15b-753f-b3d0-f1f76701c1ca.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hebisd.edu/BedfordJH",
      "poi_directions_map_url": "https://maps.google.com/?cid=14470394027529366915&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bedford-junior-high-school",
      "poi_latitude": "32.8552695",
      "poi_longitude": "-97.1629592",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-399-3122",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-25bd-7650-b3e5-cf64de4e7e00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-25bd-7650-b3e5-cf64de4e7e00",
        "storage_key": "property/5767160559304704/019d02f5-25bd-7650-b3e5-cf64de4e7e00.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-46_4UZ_ToYRg23SWrMq0cg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_0e188de40db10de1f910fb10",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Central Junior High",
      "poi_type": "Education",
      "poi_address": "3191 W Pipeline Rd, Euless, TX 76040, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-a1b7-7482-b853-073ddbd6397e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-a1b7-7482-b853-073ddbd6397e",
        "storage_key": "property/5767160559304704/019f14ea-a1b7-7482-b853-073ddbd6397e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hebisd.edu/CentralJH",
      "poi_directions_map_url": "https://maps.google.com/?cid=275913659391756903&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-junior-high",
      "poi_latitude": "32.8209563",
      "poi_longitude": "-97.1385481",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-399-3360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-25bd-7650-b3e5-cf64de4e7e00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-25bd-7650-b3e5-cf64de4e7e00",
        "storage_key": "property/5767160559304704/019d02f5-25bd-7650-b3e5-cf64de4e7e00.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJexQjAPl-ToYRZ0q56AI-1AM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "ec_263ccd60eb324a752c8c2244",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "L.D. Bell High School",
      "poi_type": "Education",
      "poi_address": "1601 Brown Trail, Hurst, TX 76054, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-a23e-708a-9d0e-ee2339f791ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-a23e-708a-9d0e-ee2339f791ea",
        "storage_key": "property/5767160559304704/019f14ea-a23e-708a-9d0e-ee2339f791ea.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.hebisd.edu/LDBell",
      "poi_directions_map_url": "https://maps.google.com/?cid=4557705008725231755&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ld-bell-high-school",
      "poi_latitude": "32.8428726",
      "poi_longitude": "-97.1605018",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-399-3230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-25bd-7650-b3e5-cf64de4e7e00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-25bd-7650-b3e5-cf64de4e7e00",
        "storage_key": "property/5767160559304704/019d02f5-25bd-7650-b3e5-cf64de4e7e00.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDZFtWDx_ToYRiwgWxI44QD8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_c6597f884e1cb4da8ce2d8bb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Gene A. Buinger Career & Technical Education Academy",
      "poi_type": "Education",
      "poi_address": "GENE A. BUINGER ACADEMY BLDG E 6017, 1849 Central Dr, Bedford, TX 76022, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-a40c-71ba-a11f-e2529207cbc4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-a40c-71ba-a11f-e2529207cbc4",
        "storage_key": "property/5767160559304704/019f14ea-a40c-71ba-a11f-e2529207cbc4.webp",
        "width": 1280,
        "height": 873
      },
      "poi_business_url": "https://www.hebisd.edu/BCTEA",
      "poi_directions_map_url": "https://maps.google.com/?cid=7563960283354823195&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gene-a-buinger-career--technical-education-academy",
      "poi_latitude": "32.835262",
      "poi_longitude": "-97.136743",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-399-2220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-25bd-7650-b3e5-cf64de4e7e00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-25bd-7650-b3e5-cf64de4e7e00",
        "storage_key": "property/5767160559304704/019d02f5-25bd-7650-b3e5-cf64de4e7e00.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQ6coE6p_ToYRG_qGWM2V-Gg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_675c0cf200aac758f62558cb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Primrose School of Bedford",
      "poi_type": "Education",
      "poi_address": "3916 Central Dr, Bedford, TX 76021, USA",
      "poi_short_description": "Day care featuring an age-appropriate curriculum and a safe learning environment.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-a489-72cf-9d8a-c3ebde9b704a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-a489-72cf-9d8a-c3ebde9b704a",
        "storage_key": "property/5767160559304704/019f14ea-a489-72cf-9d8a-c3ebde9b704a.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.primroseschools.com/schools/bedford/?utm_source=gbp&utm_medium=maplistings",
      "poi_directions_map_url": "https://maps.google.com/?cid=1085990327275471417&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primrose-school-of-bedford",
      "poi_latitude": "32.866166",
      "poi_longitude": "-97.130657",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 817-545-5485",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-25bd-7650-b3e5-cf64de4e7e00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-25bd-7650-b3e5-cf64de4e7e00",
        "storage_key": "property/5767160559304704/019d02f5-25bd-7650-b3e5-cf64de4e7e00.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVxa0QoN_ToYROcLD5nI2Eg8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_146324dccabe20730c065c48",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Messenger College",
      "poi_type": "Education",
      "poi_address": "2705 Brown Trail #408, Bedford, TX 76021, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-a4f1-716f-b7bd-513353229a5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-a4f1-716f-b7bd-513353229a5c",
        "storage_key": "property/5767160559304704/019f14ea-a4f1-716f-b7bd-513353229a5c.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.messengercollege.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13044519956730921655&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "messenger-college",
      "poi_latitude": "32.8507986",
      "poi_longitude": "-97.1607416",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-554-5950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-25bd-7650-b3e5-cf64de4e7e00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-25bd-7650-b3e5-cf64de4e7e00",
        "storage_key": "property/5767160559304704/019d02f5-25bd-7650-b3e5-cf64de4e7e00.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJtzkhv9FkyIcRt8JwrslxB7U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_8245b5230f8d024441a5affd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Movie Tavern Bedford",
      "poi_type": "Entertainment",
      "poi_address": "2204 Airport Fwy Suite 450, Bedford, TX 76022, USA",
      "poi_short_description": "Theater showing new releases paired with gourmet eats & cocktails available at the push of a button.",
      "poi_long_description": "Theater showing new releases paired with gourmet eats & cocktails available at the push of a button.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-a682-72f5-9247-2987d67af25c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-a682-72f5-9247-2987d67af25c",
        "storage_key": "property/5767160559304704/019f14ea-a682-72f5-9247-2987d67af25c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.marcustheatres.com/theatre-locations/state-TX?Brand=Movie+Tavern",
      "poi_directions_map_url": "https://maps.google.com/?cid=16306300885807664701&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "movie-tavern-bedford",
      "poi_latitude": "32.8346977",
      "poi_longitude": "-97.1320419",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-768-6414",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-e8c5-728a-831a-72e6860da7e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-e8c5-728a-831a-72e6860da7e7",
        "storage_key": "property/5767160559304704/019f14ea-e8c5-728a-831a-72e6860da7e7.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9T4SBax_ToYRPQ4020KeS-I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_83b9b1875de49f0b0fe9ac01",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Cinemark North East Mall 18 and XD",
      "poi_type": "Entertainment",
      "poi_address": "1101 Melbourne Rd Ste 6000, Hurst, TX 76053, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-a5b3-704e-85ad-06b847ec0e19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-a5b3-704e-85ad-06b847ec0e19",
        "storage_key": "property/5767160559304704/019f14ea-a5b3-704e-85ad-06b847ec0e19.webp",
        "width": 597,
        "height": 365
      },
      "poi_business_url": "https://www.cinemark.com/theatres/tx-hurst/north-east-mall-18-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTI5MTAtNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=7078470057035781729&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-north-east-mall-18-and-xd",
      "poi_latitude": "32.8289919",
      "poi_longitude": "-97.2013966",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-591-8540",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-e8c5-728a-831a-72e6860da7e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-e8c5-728a-831a-72e6860da7e7",
        "storage_key": "property/5767160559304704/019f14ea-e8c5-728a-831a-72e6860da7e7.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJQydlZeB4ToYRYVbbdgPHO2I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_57ea7ed08b985eab1d4936b3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Bedford Ice House",
      "poi_type": "Entertainment",
      "poi_address": "2250 Airport Fwy #300, Bedford, TX 76022, USA",
      "poi_short_description": "Dynamic, unpretentious hangout with cocktails, pub grub, outdoor seating & live music.",
      "poi_long_description": "Dynamic, unpretentious hangout with cocktails, pub grub, outdoor seating & live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-ab2e-7449-b6cc-4c3806f19812.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-ab2e-7449-b6cc-4c3806f19812",
        "storage_key": "property/5767160559304704/019f14ea-ab2e-7449-b6cc-4c3806f19812.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://bedfordicehouse.com/?utm_source=extnet&utm_medium=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=13427508182967239232&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bedford-ice-house",
      "poi_latitude": "32.8352779",
      "poi_longitude": "-97.1313598",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-864-9898",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-e8c9-730a-bc52-dd6b7599ef89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-e8c9-730a-bc52-dd6b7599ef89",
        "storage_key": "property/5767160559304704/019f14ea-e8c9-730a-bc52-dd6b7599ef89.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAb0p4qt_ToYRQMJp6IwXWLo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_d2379b0f5b13e7ad1b90f25b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Toadies Bar and Grill",
      "poi_type": "Entertainment",
      "poi_address": "1705 Airport Fwy, Bedford, TX 76021, USA",
      "poi_short_description": "Lively watering hole with patio seating & American chow, including sandwiches & fried fare.",
      "poi_long_description": "Lively watering hole with patio seating & American chow, including sandwiches & fried fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-a731-753d-bcb1-a3a1499969db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-a731-753d-bcb1-a3a1499969db",
        "storage_key": "property/5767160559304704/019f14ea-a731-753d-bcb1-a3a1499969db.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://toadiesbarandgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13155222745530500749&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "toadies-bar-and-grill",
      "poi_latitude": "32.837662",
      "poi_longitude": "-97.1398241",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-283-9090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-e8c9-730a-bc52-dd6b7599ef89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-e8c9-730a-bc52-dd6b7599ef89",
        "storage_key": "property/5767160559304704/019f14ea-e8c9-730a-bc52-dd6b7599ef89.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmZCzwgZ_ToYRjQZ8QGO9kLY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "ec_28dec2d51fdd70ff841dcb12",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Big Shots Sports Cafe",
      "poi_type": "Entertainment",
      "poi_address": "1601 Airport Fwy, Bedford, TX 76021, USA",
      "poi_short_description": "Sports bar adding live music, karaoke, pool & poker to the mix, plus pub food & shot specials.",
      "poi_long_description": "Sports bar adding live music, karaoke, pool & poker to the mix, plus pub food & shot specials.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-a7ff-75b3-bc70-4f0993cb1a0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-a7ff-75b3-bc70-4f0993cb1a0b",
        "storage_key": "property/5767160559304704/019f14ea-a7ff-75b3-bc70-4f0993cb1a0b.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.bigshotssportscafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13304691341852642664&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "big-shots-sports-cafe",
      "poi_latitude": "32.8378246",
      "poi_longitude": "-97.1413628",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-510-1310",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-e8c9-730a-bc52-dd6b7599ef89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-e8c9-730a-bc52-dd6b7599ef89",
        "storage_key": "property/5767160559304704/019f14ea-e8c9-730a-bc52-dd6b7599ef89.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkdTWHgd_ToYRaI1XvUjCo7g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_bar"
    },
    {
      "id": "ec_3412455477d6550c08ad9c4f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "NRH2O Family Water Park",
      "poi_type": "Entertainment",
      "poi_address": "9001 Blvd 26, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Pools, a water playground & a lazy river are among the offerings at this water park.",
      "poi_long_description": "Pools, a water playground & a lazy river are among the offerings at this water park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f4-ec69-775a-b612-af8c421dcb2e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f4-ec69-775a-b612-af8c421dcb2e",
        "storage_key": "property/5767160559304704/019d02f4-ec69-775a-b612-af8c421dcb2e.webp",
        "width": 1280,
        "height": 768
      },
      "poi_business_url": "http://www.nrh2o.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1179881649457106072&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nrh2o-family-water-park",
      "poi_latitude": "32.8500662",
      "poi_longitude": "-97.1945008",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-427-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-2a7e-72da-95d6-f8b8dae6b23b",
        "storage_key": "property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUxJqg7h4ToYRmIzk4BvIXxA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "ec_c188d8f894a1c310b7563e1f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Malibu Jack's North Richland Hills",
      "poi_type": "Entertainment",
      "poi_address": "8651 Airport Fwy, North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14e9-2c02-7739-b7ae-fdf6afe7fa87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-2c02-7739-b7ae-fdf6afe7fa87",
        "storage_key": "property/5767160559304704/019f14e9-2c02-7739-b7ae-fdf6afe7fa87.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.malibujacks.net/nrh/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=14537273623760176851&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "malibu-jacks-north-richland-hills",
      "poi_latitude": "32.8372671",
      "poi_longitude": "-97.1997494",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-479-9410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-2a7e-72da-95d6-f8b8dae6b23b",
        "storage_key": "property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAUrcIwB5ToYR04bhylbFvsk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "ec_4a9f6fa88a11c556bffabf38",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "LEGOLAND® Discovery Center Dallas/Fort Worth",
      "poi_type": "Entertainment",
      "poi_address": "3000 Grapevine Mills Pkwy, Grapevine, TX 76051, USA",
      "poi_short_description": "Family entertainment center featuring Lego toy displays, rides & 4D films, plus gift shop.",
      "poi_long_description": "Family entertainment center featuring Lego toy displays, rides & 4D films, plus gift shop.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-a8c5-70ed-a3b9-12897553128b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-a8c5-70ed-a3b9-12897553128b",
        "storage_key": "property/5767160559304704/019f14ea-a8c5-70ed-a3b9-12897553128b.webp",
        "width": 701,
        "height": 467
      },
      "poi_business_url": "https://www.legolanddiscoverycenter.com/dallas-fw/?utm_source=local-listing&utm_medium=organic&utm_campaign=tickets",
      "poi_directions_map_url": "https://maps.google.com/?cid=8213318445731368129&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "legoland-discovery-center-dallasfort-worth",
      "poi_latitude": "32.9666453",
      "poi_longitude": "-97.0434661",
      "poi_miles_from_property": "12.8 mi",
      "poi_walking_minutes": "4 hours 44 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 469-444-3050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-2a7e-72da-95d6-f8b8dae6b23b",
        "storage_key": "property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwU71w4YrTIYRwUz7QJyR-3E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_a2345cc4853b51f4e2876d8a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "SEA LIFE Grapevine Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "Grapevine Mills, 3000 Grapevine Mills Pkwy, Grapevine, TX 76051, USA",
      "poi_short_description": "Family-friendly exhibits with a variety of sea creatures (most offer play areas & group packages).",
      "poi_long_description": "Family-friendly exhibits with a variety of sea creatures (most offer play areas & group packages).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-aa6c-70be-b910-6194740df3e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-aa6c-70be-b910-6194740df3e6",
        "storage_key": "property/5767160559304704/019f14ea-aa6c-70be-b910-6194740df3e6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.visitsealife.com/grapevine/?utm_source=local-listing&utm_medium=organic&utm_campaign=tickets",
      "poi_directions_map_url": "https://maps.google.com/?cid=432349789120866841&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sea-life-grapevine-aquarium",
      "poi_latitude": "32.9662578",
      "poi_longitude": "-97.0438015",
      "poi_miles_from_property": "12.8 mi",
      "poi_walking_minutes": "4 hours 44 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 469-444-3050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-2a7e-72da-95d6-f8b8dae6b23b",
        "storage_key": "property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV-3It4YrTIYRGapDr9cDAAY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "ec_4679f4a710c0f8da77fb716a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Palace Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "300 S Main St, Grapevine, TX 76051, USA",
      "poi_short_description": "Restored 1940s-era theater featuring weekly classic movies in spacious surrounds.",
      "poi_long_description": "Restored 1940s-era theater featuring weekly classic movies in spacious surrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-aab0-7171-a6d1-460fdc5920bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-aab0-7171-a6d1-460fdc5920bf",
        "storage_key": "property/5767160559304704/019f14ea-aab0-7171-a6d1-460fdc5920bf.webp",
        "width": 1250,
        "height": 832
      },
      "poi_business_url": "http://www.palace-theatre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=760093712415309344&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "palace-arts-center",
      "poi_latitude": "32.9389638",
      "poi_longitude": "-97.0785253",
      "poi_miles_from_property": "9.6 mi",
      "poi_walking_minutes": "3 hours 33 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 817-410-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-2a7e-72da-95d6-f8b8dae6b23b",
        "storage_key": "property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV4swuDsrTIYRIL6FTDRljAo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_2bde070869845d7abe345adb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Texas Health Harris Methodist Hurst-Euless-Bedford",
      "poi_type": "Health and Wellness",
      "poi_address": "1600 Hospital Pkwy, Bedford, TX 76022, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-aa78-726c-82b5-edad88fdd89d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-aa78-726c-82b5-edad88fdd89d",
        "storage_key": "property/5767160559304704/019f14ea-aa78-726c-82b5-edad88fdd89d.webp",
        "width": 1279,
        "height": 719
      },
      "poi_business_url": "https://www.texashealth.org/locations/texas-health-heb",
      "poi_directions_map_url": "https://maps.google.com/?cid=8046041147271700356&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-health-harris-methodist-hurst-euless-bedford",
      "poi_latitude": "32.8349711",
      "poi_longitude": "-97.1244698",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-848-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-2b30-764d-a677-5a6a45c8bad0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-2b30-764d-a677-5a6a45c8bad0",
        "storage_key": "property/5767160559304704/019d02f5-2b30-764d-a677-5a6a45c8bad0.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJw-xkb7J_ToYRhF9OL8tHqW8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_0e6a54ebfc82b03412031c81",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Encompass Health Rehabilitation Hospital of the Mid-Cities",
      "poi_type": "Health and Wellness",
      "poi_address": "2304 State Hwy 121, Bedford, TX 76021, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-aa68-7770-9e5a-2bc682d7843b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-aa68-7770-9e5a-2bc682d7843b",
        "storage_key": "property/5767160559304704/019f14ea-aa68-7770-9e5a-2bc682d7843b.webp",
        "width": 749,
        "height": 421
      },
      "poi_business_url": "https://www.encompasshealth.com/locations/mid-cities-rehab?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=6113797415279657114&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "encompass-health-rehabilitation-hospital-of-the-mid-cities",
      "poi_latitude": "32.8453395",
      "poi_longitude": "-97.1132183",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 817-684-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-2a7e-72da-95d6-f8b8dae6b23b",
        "storage_key": "property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDfsudrh_ToYRmgByXluS2FQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "ec_fe18bd80a9126b22ad70d510",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "WithCare Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "2200 Airport Fwy #550, Bedford, TX 76022, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-ae35-76db-803d-bcfd91e483c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-ae35-76db-803d-bcfd91e483c2",
        "storage_key": "property/5767160559304704/019f14ea-ae35-76db-803d-bcfd91e483c2.webp",
        "width": 1104,
        "height": 1280
      },
      "poi_business_url": "https://www.withcareclinic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=885425838882029726&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "withcare-clinic",
      "poi_latitude": "32.8342759",
      "poi_longitude": "-97.1325215",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 469-949-6080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-2a7e-72da-95d6-f8b8dae6b23b",
        "storage_key": "property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq7Jwb_V_ToYRngCE-RuqSQw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_77ac37746c3ff5e28908cb43",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "WithCare Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "2200 Airport Fwy #550, Bedford, TX 76022, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-add0-7275-9c00-d6bec7386edc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-add0-7275-9c00-d6bec7386edc",
        "storage_key": "property/5767160559304704/019f14ea-add0-7275-9c00-d6bec7386edc.webp",
        "width": 1104,
        "height": 1280
      },
      "poi_business_url": "https://www.withcareclinic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=885425838882029726&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "withcare-clinic",
      "poi_latitude": "32.8342759",
      "poi_longitude": "-97.1325215",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 469-949-6080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-2a7e-72da-95d6-f8b8dae6b23b",
        "storage_key": "property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq7Jwb_V_ToYRngCE-RuqSQw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_eff13f4f15c131ab29bc5a86",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2900 Central Dr, Bedford, TX 76021, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-9680-76b9-981a-60d54e87e596.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-9680-76b9-981a-60d54e87e596",
        "storage_key": "property/5767160559304704/019f14ea-9680-76b9-981a-60d54e87e596.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/bedford-tx-pharmacies/2900-central-dr-bedford-tx-76021/storeid=7449?WT.mc_id=LS_GOOGLE_RX_7449",
      "poi_directions_map_url": "https://maps.google.com/?cid=14103719006248815440&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "32.8524047",
      "poi_longitude": "-97.1315133",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-571-7979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-e896-750a-b4a4-ed22ad087cc6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-e896-750a-b4a4-ed22ad087cc6",
        "storage_key": "property/5767160559304704/019f14ea-e896-750a-b4a4-ed22ad087cc6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNUWB5aF_ToYRUMtiI7Z5usM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_c91049bf707d158ca0018af9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2253 Central Dr, Bedford, TX 76021, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-b0ab-750f-a0e9-6718ff847c4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-b0ab-750f-a0e9-6718ff847c4e",
        "storage_key": "property/5767160559304704/019f14ea-b0ab-750f-a0e9-6718ff847c4e.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-2253+central+dr-bedford-tx-76021/id=3881",
      "poi_directions_map_url": "https://maps.google.com/?cid=13039587730601294609&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "32.8442443",
      "poi_longitude": "-97.1341208",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-868-9202",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-e896-750a-b4a4-ed22ad087cc6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-e896-750a-b4a4-ed22ad087cc6",
        "storage_key": "property/5767160559304704/019f14ea-e896-750a-b4a4-ed22ad087cc6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW8NNpKd_ToYRETsITPTr9bQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_fa637a6aabf4c3f81d529099",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2108 Bedford Rd, Bedford, TX 76021, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-af13-72f5-98e4-a79953776dcb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-af13-72f5-98e4-a79953776dcb",
        "storage_key": "property/5767160559304704/019f14ea-af13-72f5-98e4-a79953776dcb.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/3392-bedford-tx/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=12530364683417317990&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "32.8435155",
      "poi_longitude": "-97.1321519",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-283-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-e896-750a-b4a4-ed22ad087cc6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-e896-750a-b4a4-ed22ad087cc6",
        "storage_key": "property/5767160559304704/019f14ea-e896-750a-b4a4-ed22ad087cc6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw5OJCqd_ToYRZnIwdUrM5K0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_ffb3811fb05e6589d39daba2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "The Bedford Center YMCA | YMCA of Fort Worth",
      "poi_type": "Health and Wellness",
      "poi_address": "2801 Forest Ridge Dr, Bedford, TX 76021, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-b34b-7338-bd77-03c05ecabd83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-b34b-7338-bd77-03c05ecabd83",
        "storage_key": "property/5767160559304704/019f14ea-b34b-7338-bd77-03c05ecabd83.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://ymcafw.org/locations/bedford-center-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=6890165811885098163&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-bedford-center-ymca--ymca-of-fort-worth",
      "poi_latitude": "32.8494437",
      "poi_longitude": "-97.1482285",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-725-8439",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-25bd-7650-b3e5-cf64de4e7e00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-25bd-7650-b3e5-cf64de4e7e00",
        "storage_key": "property/5767160559304704/019d02f5-25bd-7650-b3e5-cf64de4e7e00.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ26N3Vpl_ToYRs8Tz3EzJnl8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "ec_2a00bae553a0839da5237cba",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "372 E Pipeline Rd, Hurst, TX 76053, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14e9-3a70-7089-8fb6-fd5254787f52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-3a70-7089-8fb6-fd5254787f52",
        "storage_key": "property/5767160559304704/019f14e9-3a70-7089-8fb6-fd5254787f52.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/hurst-pipeline-rd-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=1588963071271522572&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "32.8219078",
      "poi_longitude": "-97.1628595",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 682-253-1503",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-2a7e-72da-95d6-f8b8dae6b23b",
        "storage_key": "property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg4yhjNt-ToYRDFFaoH4hDRY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_cdf10c0ac143462c267247fa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "HOTWORX - Euless, TX - DFW Airport-South",
      "poi_type": "Health and Wellness",
      "poi_address": "900 N Industrial Blvd, Euless, TX 76039, USA",
      "poi_short_description": "Boutique-style gym providing a variety of virtually instructed isometric workouts in infrared saunas.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-b103-70d9-bcb1-c294424de98a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-b103-70d9-bcb1-c294424de98a",
        "storage_key": "property/5767160559304704/019f14ea-b103-70d9-bcb1-c294424de98a.webp",
        "width": 554,
        "height": 312
      },
      "poi_business_url": "https://www.hotworx.net/studio/euless-nindustrialblvd?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=16342748864356388947&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hotworx---euless-tx---dfw-airport-south",
      "poi_latitude": "32.8490634",
      "poi_longitude": "-97.0993512",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-900-2160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-25bd-7650-b3e5-cf64de4e7e00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-25bd-7650-b3e5-cf64de4e7e00",
        "storage_key": "property/5767160559304704/019d02f5-25bd-7650-b3e5-cf64de4e7e00.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFSBcTb1_ToYRU5BhKYEbzeI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_0d130552683c9358496aa72b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Generations Park at Boys Ranch",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2801 Forest Ridge Dr, Bedford, TX 76021, USA",
      "poi_short_description": "Park with a playground as well as a water area for youngsters and adults.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-b5a0-7001-983f-7578910d79b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-b5a0-7001-983f-7578910d79b2",
        "storage_key": "property/5767160559304704/019f14ea-b5a0-7001-983f-7578910d79b2.webp",
        "width": 1280,
        "height": 958
      },
      "poi_business_url": "https://bedfordtx.gov/454/Generations-Park-at-Boys-Ranch",
      "poi_directions_map_url": "https://maps.google.com/?cid=15271839672042243355&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "generations-park-at-boys-ranch",
      "poi_latitude": "32.8500342",
      "poi_longitude": "-97.1449222",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-952-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-3002-7018-bf65-947751a8fef8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-3002-7018-bf65-947751a8fef8",
        "storage_key": "property/5767160559304704/019d02f5-3002-7018-bf65-947751a8fef8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJbTQT6fB_ToYRG8XLnkR58NM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_8ecb6a4317f2aa09b45adbf3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Bedford Bark Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3200 Meadow Park Dr, Bedford, TX 76021, USA",
      "poi_short_description": "Open space for dogs to socialize and play, plus benches, trails and clean-up stations.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-b5b9-74cf-850b-7cdd2da31b07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-b5b9-74cf-850b-7cdd2da31b07",
        "storage_key": "property/5767160559304704/019f14ea-b5b9-74cf-850b-7cdd2da31b07.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bedfordtx.gov/793/Bark-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=15088548513248018076&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bedford-bark-park",
      "poi_latitude": "32.8559097",
      "poi_longitude": "-97.1350686",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-952-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-3002-7018-bf65-947751a8fef8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-3002-7018-bf65-947751a8fef8",
        "storage_key": "property/5767160559304704/019d02f5-3002-7018-bf65-947751a8fef8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQwEP6p9_ToYRnH5lJO5KZdE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "ec_7b9a476dedbb1c531c3a6ddc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Brook Hollow Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "752 Rankin Dr, Bedford, TX 76022, USA",
      "poi_short_description": "Family-friendly play space with a climbing area and slides, along with a paved walking trail.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-bc5b-718a-b801-285a2767d001.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-bc5b-718a-b801-285a2767d001",
        "storage_key": "property/5767160559304704/019f14ea-bc5b-718a-b801-285a2767d001.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://bedfordtx.gov/795/Brook-Hollow-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=967710100018973644&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brook-hollow-park",
      "poi_latitude": "32.8247687",
      "poi_longitude": "-97.1513298",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-952-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-3002-7018-bf65-947751a8fef8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-3002-7018-bf65-947751a8fef8",
        "storage_key": "property/5767160559304704/019d02f5-3002-7018-bf65-947751a8fef8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJl_qT9-N-ToYRzEswdTX_bQ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_6aa459fe5fe6bbbe0ea81044",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Central Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1201 Central Dr, Bedford, TX 76022, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-9d7b-75d8-bc0b-53170b7ed0e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-9d7b-75d8-bc0b-53170b7ed0e2",
        "storage_key": "property/5767160559304704/019f14ea-9d7b-75d8-bc0b-53170b7ed0e2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bedfordtx.gov/797/Central-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16946138223623832225&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-park",
      "poi_latitude": "32.8308545",
      "poi_longitude": "-97.1341987",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-952-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-3002-7018-bf65-947751a8fef8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-3002-7018-bf65-947751a8fef8",
        "storage_key": "property/5767160559304704/019d02f5-3002-7018-bf65-947751a8fef8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_S4KBHl_ToYRoYLEDe7GLOs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_1ff97c8c809d6bf437b5cd83",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Carousel Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Carousel Park, 1100 Simpson Terrace, Bedford, TX 76021, USA",
      "poi_short_description": "This community park spanning one acre offers play structures & plenty of tree-shaded space.",
      "poi_long_description": "This community park spanning one acre offers play structures & plenty of tree-shaded space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-b9a1-739c-8ff8-12373e9612be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-b9a1-739c-8ff8-12373e9612be",
        "storage_key": "property/5767160559304704/019f14ea-b9a1-739c-8ff8-12373e9612be.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://bedfordtx.gov/796/Carousel-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9869507532389123190&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carousel-park",
      "poi_latitude": "32.8611256",
      "poi_longitude": "-97.1523189",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 817-952-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-3002-7018-bf65-947751a8fef8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-3002-7018-bf65-947751a8fef8",
        "storage_key": "property/5767160559304704/019d02f5-3002-7018-bf65-947751a8fef8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJn3MkLm9_ToYRdoQYUM-I94g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_f820607e1bdd29d78ba895da",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Dewey Tennant Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "901 Monterrey St, Bedford, TX 76022, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-c0a7-715e-9632-0d88457a9c97.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-c0a7-715e-9632-0d88457a9c97",
        "storage_key": "property/5767160559304704/019f14ea-c0a7-715e-9632-0d88457a9c97.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bedfordtx.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=439756871778547850&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dewey-tennant-park",
      "poi_latitude": "32.8241093",
      "poi_longitude": "-97.1415115",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-952-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-3002-7018-bf65-947751a8fef8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-3002-7018-bf65-947751a8fef8",
        "storage_key": "property/5767160559304704/019d02f5-3002-7018-bf65-947751a8fef8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJp2TYJ-t_ToYRirjlgYtUGgY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_992caad9550d66bd6a1db4ff",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "East End Trail Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3700 Hastings Pl, Bedford, TX 76021, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-b9f1-73b8-85e3-7f89e984b665.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-b9f1-73b8-85e3-7f89e984b665",
        "storage_key": "property/5767160559304704/019f14ea-b9f1-73b8-85e3-7f89e984b665.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bedfordtx.gov/799/East-End-Trail-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=5941866782082827483&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "east-end-trail-park",
      "poi_latitude": "32.8620963",
      "poi_longitude": "-97.1110256",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-952-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-3002-7018-bf65-947751a8fef8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-3002-7018-bf65-947751a8fef8",
        "storage_key": "property/5767160559304704/019d02f5-3002-7018-bf65-947751a8fef8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJG9L6iUB_ToYR24S9YFvAdVI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_9a98a9534a17a536b04ca129",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Harris Ryals Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Bedford, TX 76021, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-bcbc-701c-9143-a3781767be4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-bcbc-701c-9143-a3781767be4c",
        "storage_key": "property/5767160559304704/019f14ea-bcbc-701c-9143-a3781767be4c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bedfordtx.gov/800/Harris-Ryals-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=10707763129201414480&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harris-ryals-park",
      "poi_latitude": "32.8589854",
      "poi_longitude": "-97.1252968",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 817-952-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-3002-7018-bf65-947751a8fef8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-3002-7018-bf65-947751a8fef8",
        "storage_key": "property/5767160559304704/019d02f5-3002-7018-bf65-947751a8fef8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJBy9UIzV_ToYRUFETd9WdmZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_b2cdbba321038717df2a88dd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Old Bedford School",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2400 School Ln, Bedford, TX 76021, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-c165-74ac-8ecf-3adb3fff528d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-c165-74ac-8ecf-3adb3fff528d",
        "storage_key": "property/5767160559304704/019f14ea-c165-74ac-8ecf-3adb3fff528d.webp",
        "width": 1280,
        "height": 842
      },
      "poi_business_url": "http://www.oldbedfordschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7824978194468413087&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-bedford-school",
      "poi_latitude": "32.84638170000001",
      "poi_longitude": "-97.1404787",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-952-2290",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-25bd-7650-b3e5-cf64de4e7e00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-25bd-7650-b3e5-cf64de4e7e00",
        "storage_key": "property/5767160559304704/019d02f5-25bd-7650-b3e5-cf64de4e7e00.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQajTQwl_ToYRn553mDXol2w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_85abc92e1e12977cbf559575",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Stormie Jones Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2700 Brasher Ln, Bedford, TX 76021, USA",
      "poi_short_description": "Cozy park featuring a playground, soccer fields and various benches.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-bbf2-72cd-bf41-7ccdff37d3b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-bbf2-72cd-bf41-7ccdff37d3b8",
        "storage_key": "property/5767160559304704/019f14ea-bbf2-72cd-bf41-7ccdff37d3b8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.bedfordtx.gov/parks/#stormie",
      "poi_directions_map_url": "https://maps.google.com/?cid=12476369858625914344&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stormie-jones-park",
      "poi_latitude": "32.8479816",
      "poi_longitude": "-97.1025522",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-952-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-3002-7018-bf65-947751a8fef8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-3002-7018-bf65-947751a8fef8",
        "storage_key": "property/5767160559304704/019d02f5-3002-7018-bf65-947751a8fef8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJf1bvQdt_ToYR6MXJpUj4JK0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_593f5b612361daac6019c879",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Bell",
      "poi_type": "Transportation & Transit",
      "poi_address": "3232 Bell Flight Blvd, Hurst, TX 76053, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14e9-56f8-70be-9d6b-ddeee72944bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-56f8-70be-9d6b-ddeee72944bf",
        "storage_key": "property/5767160559304704/019f14e9-56f8-70be-9d6b-ddeee72944bf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://trinityrailwayexpress.org/station/bell-station/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11367673502258708933&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bell",
      "poi_latitude": "32.8046324",
      "poi_longitude": "-97.1551139",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-215-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-300c-73f8-a7b9-e255caab1321.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-300c-73f8-a7b9-e255caab1321",
        "storage_key": "property/5767160559304704/019d02f5-300c-73f8-a7b9-e255caab1321.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJmSKsN5V-ToYRxUHAYNIWwp0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_e58adf0d45bc6bfbf1ddee55",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "CentrePort/DFW Airport Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "14470 Statler Blvd, Fort Worth, TX 76155, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-c69b-758a-a20f-4e1cfc2a594f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-c69b-758a-a20f-4e1cfc2a594f",
        "storage_key": "property/5767160559304704/019f14ea-c69b-758a-a20f-4e1cfc2a594f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.dart.org/guide/transit-and-use/rail/rail-station-detail/centreport-dfw-airport-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=1619245285415004907&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "centreportdfw-airport-station",
      "poi_latitude": "32.8170102",
      "poi_longitude": "-97.0528488",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 214-979-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-e8e2-71c8-bfe5-99ff71bb01d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-e8e2-71c8-bfe5-99ff71bb01d2",
        "storage_key": "property/5767160559304704/019f14ea-e8e2-71c8-bfe5-99ff71bb01d2.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJN7AqJ-KAToYR6ypjCQK3eBY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_15a80ae184b64bbaa13c9933",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Fort Worth Central",
      "poi_type": "Transportation & Transit",
      "poi_address": "1001 Jones St, Fort Worth, TX 76102, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-c7a4-75d7-b465-c7216be8706c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-c7a4-75d7-b465-c7216be8706c",
        "storage_key": "property/5767160559304704/019f14ea-c7a4-75d7-b465-c7216be8706c.webp",
        "width": 1280,
        "height": 820
      },
      "poi_business_url": "http://ridetrinitymetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16666534907176730361&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-worth-central",
      "poi_latitude": "32.7526669",
      "poi_longitude": "-97.3264798",
      "poi_miles_from_property": "13.3 mi",
      "poi_walking_minutes": "4 hours 58 mins",
      "poi_biking_minutes": "1 hour 25 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 817-215-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-300c-73f8-a7b9-e255caab1321.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-300c-73f8-a7b9-e255caab1321",
        "storage_key": "property/5767160559304704/019d02f5-300c-73f8-a7b9-e255caab1321.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJZbEKLz5xToYR-b7q6jFtS-c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_6c688d1f614a4cf228ed9b76",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Grapevine/Main Street Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "801 S Main St, Grapevine, TX 76051, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-c9ef-770c-aad7-5af575dea67b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-c9ef-770c-aad7-5af575dea67b",
        "storage_key": "property/5767160559304704/019f14ea-c9ef-770c-aad7-5af575dea67b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://ridetrinitymetro.org/texrail/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18405502107178557258&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grapevinemain-street-station",
      "poi_latitude": "32.9338028",
      "poi_longitude": "-97.0772663",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 29 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 817-215-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-2a7e-72da-95d6-f8b8dae6b23b",
        "storage_key": "property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEz-M8e0rTIYRSt8UY6Z6bf8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_1417b1581aad4f8bbb57c778",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "DFW Airport North TEXRail Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1867 E Dallas Rd, Grapevine, TX 76051, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-c7fc-72cf-814d-d178bea76161.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-c7fc-72cf-814d-d178bea76161",
        "storage_key": "property/5767160559304704/019f14ea-c7fc-72cf-814d-d178bea76161.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ridetrinitymetro.org/stations/dfw-airport-north-station/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6621859291758648515&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dfw-airport-north-texrail-station",
      "poi_latitude": "32.9337128",
      "poi_longitude": "-97.0541165",
      "poi_miles_from_property": "10.7 mi",
      "poi_walking_minutes": "3 hours 58 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 817-215-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-2a7e-72da-95d6-f8b8dae6b23b",
        "storage_key": "property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOV8hQtwrTIYRw9zkFfGR5Vs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_617356d2441c0299360dc4c9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "North Richland Hills/Iron Horse Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-cf7c-7218-9ecb-a74db453ae21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-cf7c-7218-9ecb-a74db453ae21",
        "storage_key": "property/5767160559304704/019f14ea-cf7c-7218-9ecb-a74db453ae21.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5631713715274185447&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-richland-hillsiron-horse-station",
      "poi_latitude": "32.8447652",
      "poi_longitude": "-97.2494671",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-2a7e-72da-95d6-f8b8dae6b23b",
        "storage_key": "property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjWX3dj54ToYR5_qcM8ndJ04",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tram_stop"
    },
    {
      "id": "ec_f0ff4e095e39997ffaabaa3b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "North Richland Hills/Smithfield TEXRail Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "6420 Smithfield Rd, North Richland Hills, TX 76182, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-cbf1-73c0-bc0e-c56ed499ff14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-cbf1-73c0-bc0e-c56ed499ff14",
        "storage_key": "property/5767160559304704/019f14ea-cbf1-73c0-bc0e-c56ed499ff14.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ridetrinitymetro.org/stations/north-richland-hills-smithfield-station/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17453827278972292890&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-richland-hillssmithfield-texrail-station",
      "poi_latitude": "32.8640386",
      "poi_longitude": "-97.2116058",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 817-215-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-2a7e-72da-95d6-f8b8dae6b23b",
        "storage_key": "property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSQM5-j55ToYRGo8qlm9zOPI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_aa4c1fa3da6d366ce7e2be3a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Dallas Fort Worth International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2400 Aviation Dr, DFW Airport, TX 75261, USA",
      "poi_short_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_long_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-cdd4-77b3-b4fa-ba98a40b9f15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-cdd4-77b3-b4fa-ba98a40b9f15",
        "storage_key": "property/5767160559304704/019f14ea-cdd4-77b3-b4fa-ba98a40b9f15.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dfwairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8300766736265584668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dallas-fort-worth-international-airport",
      "poi_latitude": "32.8921983",
      "poi_longitude": "-97.0391232",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 29 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 972-973-3112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-e896-750a-b4a4-e873247a3b13.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-e896-750a-b4a4-e873247a3b13",
        "storage_key": "property/5767160559304704/019f14ea-e896-750a-b4a4-e873247a3b13.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJpyoiDWYqTIYRHCB9Bl4_MnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_d55c4945973b6232c103e7cf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "HEB ISD Administration Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1849 Central Dr, Bedford, TX 76022, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-cf01-7469-a1f0-39eb000fe08f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-cf01-7469-a1f0-39eb000fe08f",
        "storage_key": "property/5767160559304704/019f14ea-cf01-7469-a1f0-39eb000fe08f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.hebisd.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11828638531553007483&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heb-isd-administration-building",
      "poi_latitude": "32.8352588",
      "poi_longitude": "-97.1342016",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-283-4461",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-25bd-7650-b3e5-cf64de4e7e00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-25bd-7650-b3e5-cf64de4e7e00",
        "storage_key": "property/5767160559304704/019d02f5-25bd-7650-b3e5-cf64de4e7e00.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQ6coE6p_ToYRexe32RLEJ6Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_985117ed9646b4cda366a6d9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Bedford City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2000 Forest Ridge Dr, Bedford, TX 76021, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-d0a9-7525-aaa1-c806d5d58991.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-d0a9-7525-aaa1-c806d5d58991",
        "storage_key": "property/5767160559304704/019f14ea-d0a9-7525-aaa1-c806d5d58991.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://bedfordtx.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1838246782498271134&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bedford-city-hall",
      "poi_latitude": "32.84112",
      "poi_longitude": "-97.1407701",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-952-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-e8f0-70bf-8f14-06d642e5eea9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-e8f0-70bf-8f14-06d642e5eea9",
        "storage_key": "property/5767160559304704/019f14ea-e8f0-70bf-8f14-06d642e5eea9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPebRBQZ_ToYRnm9QkLXDghk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "ec_794a85668039719edbbd0007",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "American Airlines - Skyview 7",
      "poi_type": "Major Employers & Offices",
      "poi_address": "RWFJ+R6, Transformation Way, Fort Worth, TX 76155, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-d1e3-7442-849a-33c3d33122cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-d1e3-7442-849a-33c3d33122cd",
        "storage_key": "property/5767160559304704/019f14ea-d1e3-7442-849a-33c3d33122cd.webp",
        "width": 1280,
        "height": 450
      },
      "poi_business_url": "http://www.aa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15492633573707074314&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "american-airlines---skyview-7",
      "poi_latitude": "32.8291621",
      "poi_longitude": "-97.0659943",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 682-278-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-2a7e-72da-95d6-f8b8dae6b23b",
        "storage_key": "property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHaLL45iBToYRCssZ3CbkANc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_b6ae810cd96fa12695f0ed52",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Dallas Fort Worth International Airport",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2400 Aviation Dr, DFW Airport, TX 75261, USA",
      "poi_short_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_long_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-d485-748b-afb0-1e207ad60a70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-d485-748b-afb0-1e207ad60a70",
        "storage_key": "property/5767160559304704/019f14ea-d485-748b-afb0-1e207ad60a70.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dfwairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8300766736265584668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dallas-fort-worth-international-airport",
      "poi_latitude": "32.8921983",
      "poi_longitude": "-97.0391232",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 29 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 972-973-3112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-e896-750a-b4a4-e873247a3b13.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-e896-750a-b4a4-e873247a3b13",
        "storage_key": "property/5767160559304704/019f14ea-e896-750a-b4a4-e873247a3b13.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJpyoiDWYqTIYRHCB9Bl4_MnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_736211e0edccfce72807a25b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "United States Air Force Plant 4",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Lockheed Blvd, Fort Worth, TX 76108, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://cumulis.epa.gov/supercpad/cursites/csitinfo.cfm?id=0603610",
      "poi_directions_map_url": "https://maps.google.com/?cid=16010628610778343053&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "united-states-air-force-plant-4",
      "poi_latitude": "32.7711827",
      "poi_longitude": "-97.4502721",
      "poi_miles_from_property": "23.7 mi",
      "poi_walking_minutes": "8 hours 52 mins",
      "poi_biking_minutes": "2 hours 20 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-2a7e-72da-95d6-f8b8dae6b23b",
        "storage_key": "property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbSVNmIQLToYRjSYmwOQtMd4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_8132bc13581bee9bf7b3615f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Bell",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3255 Bell Flight Blvd, Fort Worth, TX 76118, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-d544-751b-abd3-2ff9bf63b4f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-d544-751b-abd3-2ff9bf63b4f2",
        "storage_key": "property/5767160559304704/019f14ea-d544-751b-abd3-2ff9bf63b4f2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.bellflight.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2708728753638745052&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bell",
      "poi_latitude": "32.8080827",
      "poi_longitude": "-97.1564018",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-280-2011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-2a7e-72da-95d6-f8b8dae6b23b",
        "storage_key": "property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6fcbcMB-ToYR3COGMXNWlyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_1e21a6772ac07cfdfdd9ba5e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "The University of Texas at Arlington",
      "poi_type": "Major Employers & Offices",
      "poi_address": "701 S Nedderman Dr, Arlington, TX 76019, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-d86a-7049-9927-50d812e85ba9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-d86a-7049-9927-50d812e85ba9",
        "storage_key": "property/5767160559304704/019f14ea-d86a-7049-9927-50d812e85ba9.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.uta.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7808325519304865642&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-university-of-texas-at-arlington",
      "poi_latitude": "32.7292117",
      "poi_longitude": "-97.1151971",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 36 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 817-272-2011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-25bd-7650-b3e5-cf64de4e7e00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-25bd-7650-b3e5-cf64de4e7e00",
        "storage_key": "property/5767160559304704/019d02f5-25bd-7650-b3e5-cf64de4e7e00.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTVbJq219ToYRarfIhLC-XGw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_0448b0863082aea45b2d58d6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "John Peter Smith Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1500 S Main St, Fort Worth, TX 76104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-dd2a-729e-a97d-2b77cec50972.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-dd2a-729e-a97d-2b77cec50972",
        "storage_key": "property/5767160559304704/019f14ea-dd2a-729e-a97d-2b77cec50972.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.jpshealthnet.org/locations/jpshospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=12646798849451524257&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "john-peter-smith-hospital",
      "poi_latitude": "32.7277649",
      "poi_longitude": "-97.3268923",
      "poi_miles_from_property": "15.2 mi",
      "poi_walking_minutes": "5 hours 41 mins",
      "poi_biking_minutes": "1 hour 35 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 817-702-3431",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-2b30-764d-a677-5a6a45c8bad0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-2b30-764d-a677-5a6a45c8bad0",
        "storage_key": "property/5767160559304704/019d02f5-2b30-764d-a677-5a6a45c8bad0.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJe8Ld8qBxToYRoYBgR4x0gq8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_8cf1c5e888a42f1f31a012aa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Cook Children's Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "801 7th Ave, Fort Worth, TX 76104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-d9b7-7469-9911-de2d9d99c62d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-d9b7-7469-9911-de2d9d99c62d",
        "storage_key": "property/5767160559304704/019f14ea-d9b7-7469-9911-de2d9d99c62d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cookchildrens.org/medical-center/fort-worth/?utm_source=google&utm_medium=OrganicSearch&utm_campaign=yext&y_source=1_MTEzNzc5ODgtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10985657874343977757&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cook-childrens-medical-center",
      "poi_latitude": "32.737",
      "poi_longitude": "-97.340842",
      "poi_miles_from_property": "14.9 mi",
      "poi_walking_minutes": "5 hours 35 mins",
      "poi_biking_minutes": "1 hour 36 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 682-885-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-2b30-764d-a677-5a6a45c8bad0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-2b30-764d-a677-5a6a45c8bad0",
        "storage_key": "property/5767160559304704/019d02f5-2b30-764d-a677-5a6a45c8bad0.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJIS7naHpxToYRHeM-2KHldJg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_85f3902d116d2d77919a4a24",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "generator",
      "poi_name": "Texas Motor Speedway",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3545 Lone Star Cir, Fort Worth, TX 76177, USA",
      "poi_short_description": "This expansive 1.5-mile race track & arena offers many national events, including NASCAR & IndyCar.",
      "poi_long_description": "This expansive 1.5-mile race track & arena offers many national events, including NASCAR & IndyCar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14ea-db39-75fc-bd8a-500370867040.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-db39-75fc-bd8a-500370867040",
        "storage_key": "property/5767160559304704/019f14ea-db39-75fc-bd8a-500370867040.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasmotorspeedway.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4598592141015080850&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-motor-speedway",
      "poi_latitude": "33.0374821",
      "poi_longitude": "-97.284692",
      "poi_miles_from_property": "20.6 mi",
      "poi_walking_minutes": "7 hours 35 mins",
      "poi_biking_minutes": "1 hour 56 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 817-215-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f5-2a7e-72da-95d6-f8b8dae6b23b",
        "storage_key": "property/5767160559304704/019d02f5-2a7e-72da-95d6-f8b8dae6b23b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs0njwbvaTYYRkl8bGDB70T8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "race_course"
    }
  ],
  "office_hours": [
    {
      "id": "custom_ee974e0e-21a4-40f3-a076-94b38b2623f5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_f957883d-d0ff-42ee-ac6c-5d6553a3cb1a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_514d6221-c0c8-405b-a869-5a321b08efe3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_8786fa42-3529-47a8-8354-e2b49edb8c5a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_f5f36e2a-6c80-4d21-8172-170474a1a500",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "day": "SUN",
      "open_time": "13:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_fbd0516d-b253-4640-b38d-9a13f044e217",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "19:00"
    },
    {
      "id": "custom_698efc2f-8a6d-476f-89fa-a75b542f2c22",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "19:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_1b8883ed94e0c53f9df4e21b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "rating": "5",
      "name": "susan turner",
      "text": "I've been a resident of the Logan for 5+ months and I'm extremely happy with the new management. It was a very rocky start but the property manager did everything possible to rectify the issues as quickly as possible and to make sure that I was fully satisfied with the resolutions.  I'm a disabled senior woman with a service dog, living alone for the first time in 40+ years and I am so pleased with the accommodations of my 1 bedroom apartment, handicapped accessible parking and accessibility to the properties amenities. I like the quiet and safe surroundings as well as the accommodations for my service dog. Whenever I have maintenance issues the maintenance team quickly respond, to address the issue, they are so knowledgeable, friendly and accommodating. The assistant manager Tiffany, goes above her duties and checks on me regularly knowing my disabilities and taking a personal interest in me not just as a resident but as a person. In this day and time it is very rare to be a recipient of this type of care from any type of business relationship. Recently, the Logan has instituted a liaison program, filled by (Sarah) who serves as a liaison between the residents and the property management company. Whenever I have an issue of any kind she follows up after the issue is resolved to ensure that I'm thoroughly satisfied with the resolution of the issue, and this is a very successful experience for the residents and to promote goodwill and open dialog. My experience with this property has been outstanding for a new resident like myself.\nThank you,\nSusan T.",
      "date": "2026-05-23",
      "title": "false"
    },
    {
      "id": "ec_e1a0ca024499643020719e36",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "rating": "5",
      "name": "Kelea Laws",
      "text": "I’ve lived here for a little while now and can honestly say that this has been the best rental experience I’ve ever had. A friend of mine lived here years ago and when I was in the market for a new place, I immediately knew this was where I wanted to be. We’ve transferred to a new unit a couple times (shout out to American Landmark for that option being available✨) since moving here and our most recent transfer was so pain free! We’ve usually planned 2-3 months out for a transfer but due to an emergency situation we needed to get it done in under two weeks. Tiffany and Laurie were INCREDIBLE!!! They made it happen in a WEEK and it worked out so well! Got the exact unit I wanted, price was perfect and they went above and beyond to make sure we were taken care of so that we could focus on everything else. I’ve worked with a lot of the staff here but those two are literally heaven sent. I wouldn’t want to be anywhere else!",
      "date": "2026-04-27",
      "title": "false"
    },
    {
      "id": "ec_1856d8699c75ffc1bc783235",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "rating": "5",
      "name": "Kristyna Sullivan",
      "text": "I had a great experience working with Shelbi Matheny at the leasing office. From the very beginning, she was professional, responsive, and genuinely helpful throughout the entire process. She took the time to answer all of my questions, made everything feel straightforward, and never made me feel rushed or overlooked.\nWhat really stood out was her positive attitude and attention to detail, Shelbi made what can often be a stressful process feel easy and welcoming. She cares about the residents and takes pride in what she does.\nIf you’re considering moving here, I highly recommend asking for Shelbi. She truly goes above and beyond!",
      "date": "2026-05-04",
      "title": "false"
    },
    {
      "id": "ec_8d2ff23ec4bb178e35537505",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "rating": "5",
      "name": "Marcus Carden",
      "text": "I am very satisfied with the management team at our beautiful property. They had a dog day event recently held in the office and politely welcomed my Dog Roscoe and I inside for pictures, treats, and tons of love! It was very nice of them to show me pictures of their pups and share a very warming moment. The office is full of smiling faces always, and how can you say no to free Starbucks. The property is beautiful and has some really nice pools, a gym where I love to work out in, and a beautiful dog park. Ashley, Maddy, Jasmine, and Michelle are so sweet, kind, and very patient. They always brighten my day when I stop by. I would highly recommend The Logan to be your new community to live. I am highly satisfied where I live. 😊😊😊",
      "date": "2024-02-23",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_12ed532d-1bb7-4136-adde-0ef8276d4988",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f6-1d0b-77c9-80ea-e72f67b8704c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with two accent chairs, a coffee table, and a TV stand.",
        "public_id": "019d02f6-1d0b-77c9-80ea-e72f67b8704c",
        "storage_key": "property/5767160559304704/019d02f6-1d0b-77c9-80ea-e72f67b8704c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - 725SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=vb9ZgEhuR7E"
    },
    {
      "id": "custom_5829c5d4-b5dc-41d5-9962-e68ef9abcbfa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f6-12d8-718a-85ef-e90ba07c9e84.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Fully equipped gym with treadmills, ellipticals, weight machines, and free weights.",
        "public_id": "019d02f6-12d8-718a-85ef-e90ba07c9e84",
        "storage_key": "property/5767160559304704/019d02f6-12d8-718a-85ef-e90ba07c9e84.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "State-of-the-Art Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=UYRo8JG5uo7"
    },
    {
      "id": "custom_315e39be-3f13-45fc-a4a4-73bf790fee83",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f6-1383-732f-b7c1-8fb7bb625d50.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Swimming pool area with lounge chairs and umbrellas near apartment buildings.",
        "public_id": "019d02f6-1383-732f-b7c1-8fb7bb625d50",
        "storage_key": "property/5767160559304704/019d02f6-1383-732f-b7c1-8fb7bb625d50.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Resort-Inspired Pool 2",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=EF1Zu5zDkqG"
    },
    {
      "id": "custom_2d96224d-c06b-4e81-bdc5-126e1fbd73d5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f6-128e-7560-a812-ae768606c783.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Playground equipment and fenced-in area with wood chip ground cover.",
        "public_id": "019d02f6-128e-7560-a812-ae768606c783",
        "storage_key": "property/5767160559304704/019d02f6-128e-7560-a812-ae768606c783.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Dog Park",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=DDfrL3u47i8"
    },
    {
      "id": "custom_dc90512a-b61a-4be8-ad26-d3c6962fed02",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f6-12ee-72b9-b4b7-fc60487ec8b5.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Outdoor swimming pool and lounge area with seating, tables, and a building in the background.",
        "public_id": "019d02f6-12ee-72b9-b4b7-fc60487ec8b5",
        "storage_key": "property/5767160559304704/019d02f6-12ee-72b9-b4b7-fc60487ec8b5.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Resort-Inspired Pool 2",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=7Ng1DZctYYf"
    },
    {
      "id": "custom_16e6ad99-5e50-45f4-b8f6-feb745396be4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f14c2-ccf1-711e-861d-c5547a297a40.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c2-ccf1-711e-861d-c5547a297a40",
        "storage_key": "property/5767160559304704/019f14c2-ccf1-711e-861d-c5547a297a40.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "The Logan",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/uIEFdoaB_qE"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa46-658e-732f-a360-edd1732d888c",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "the-logan",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704"
    },
    {
      "lead_collector_id": "0198aa46-65f0-763b-8896-4ba4ca8dc17a",
      "lead_source": "FACEBOOK_ADS",
      "name": "the-logan",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704"
    },
    {
      "lead_collector_id": "0198aa46-6652-70d9-b143-181ac6ec01c7",
      "lead_source": "LANDING_PAGE",
      "name": "the-logan",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "custom",
      "page_item_url": "luxury-apartments-washer-dryer-bedford-tx-807",
      "search_query": "luxury apartments with washer dryer Bedford TX",
      "category": "",
      "h1_title": "Luxury Apartments in Bedford, TX",
      "h2_subtitle": "Discover your dream luxury apartment with a washer dryer in Bedford, TX. Enjoy upscale living with exceptional amenities tailored for your needs.",
      "page_copy": "Welcome to The Logan, the epitome of luxury apartments with washer dryer in Bedford, TX. These exclusive homes elevate comfort and style, offering an exceptional standard of living. Choose from our spacious one and two-bedroom floor plans featuring chef’s kitchens, tall ceilings, and sleek hard floors. Imagine indulging in modern conveniences combined with the charm of a thriving community. \n\nOur residents revel in unparalleled amenities including a sparkling swimming pool, fitness center, and vibrant pet play area. At The Logan, every detail is designed for luxury and ease, making it one of the most sought-after destinations in Bedford. Experience the ultimate in apartment living, where your ideal space awaits just a call away.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f6c13-0226-73e6-931c-35971dcc150f.webp",
      "featured_image_media": {
        "alt_text": "Stylish lounge area with a stone fireplace, comfortable seating, and modern art.",
        "public_id": "019f6c13-0226-73e6-931c-35971dcc150f",
        "storage_key": "property/5767160559304704/019f6c13-0226-73e6-931c-35971dcc150f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Washer Dryer - Bedford, TX",
      "seo_description": "Explore luxury apartments with a washer dryer at The Logan in Bedford, TX. Enjoy modern amenities and spacious floor plans for unmatched comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-dog-park-tarrant-county-62",
      "search_query": "pet friendly apartments with dog park Tarrant County",
      "category": "",
      "h1_title": "Pet-Friendly Apartments in Tarrant County",
      "h2_subtitle": "Explore our pet-friendly apartments with a dog park in Tarrant County. Enjoy a welcoming community designed with both you and your pet in mind.",
      "page_copy": "At The Logan, we believe in creating a community that welcomes all members of your household, including furry friends! Our pet-friendly apartments with a dog park in Tarrant County offer a haven for pets and their owners to thrive together. Located in the vibrant Hurst/Euless/Bedford neighborhood, our community features spacious one and two-bedroom floor plans perfect for any lifestyle.\n\nMore than just a home, The Logan provides a variety of modern amenities. Let your pets roam and socialize freely in our dedicated pet play area while you enjoy the state-of-the-art fitness center, swimming pool, and relaxation spaces. Experience a balanced, pet-friendly lifestyle where comfort and convenience are right at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f6c13-0226-73e6-931c-35971dcc150f.webp",
      "featured_image_media": {
        "alt_text": "Stylish lounge area with a stone fireplace, comfortable seating, and modern art.",
        "public_id": "019f6c13-0226-73e6-931c-35971dcc150f",
        "storage_key": "property/5767160559304704/019f6c13-0226-73e6-931c-35971dcc150f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments with Dog Park - Tarrant County",
      "seo_description": "Find pet-friendly apartments with a dog park at The Logan in Tarrant County. Enjoy modern amenities designed for you and your pet in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "custom",
      "page_item_url": "apartments-air-conditioning-hurst-euless-bedford-794",
      "search_query": "apartments with air conditioning Hurst Euless Bedford",
      "category": "",
      "h1_title": "Apartments with Air Conditioning",
      "h2_subtitle": "Discover modern apartments with air conditioning in the Hurst/Euless/Bedford area. Stay cool and comfortable at The Logan.",
      "page_copy": "The Logan offers exceptional apartments equipped with air conditioning in the desirable Hurst/Euless/Bedford area. Relish in the comfort and efficiency of climate-controlled living spaces as you navigate through seasons with ease and style. Our thoughtfully designed one and two-bedroom floor plans create the perfect backdrop for contemporary living.\n\nBeyond comfort, we provide a range of top-notch amenities to enhance your lifestyle, including a sparkling pool, a modern fitness center, and a welcoming pet play area. Experience the perfect blend of convenience and luxury, all while staying comfortably cool. Let The Logan become your peaceful retreat in the heart of Hurst/Euless/Bedford.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f6c13-0226-73e6-931c-35971dcc150f.webp",
      "featured_image_media": {
        "alt_text": "Stylish lounge area with a stone fireplace, comfortable seating, and modern art.",
        "public_id": "019f6c13-0226-73e6-931c-35971dcc150f",
        "storage_key": "property/5767160559304704/019f6c13-0226-73e6-931c-35971dcc150f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air-Conditioned Apartments – Hurst/Euless/Bedford",
      "seo_description": "Find apartments with air conditioning at The Logan in the Hurst/Euless/Bedford area. Experience comfort with top-notch amenities in a perfect location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "custom",
      "page_item_url": "modern-apartments-dishwasher-bedford-tx-681",
      "search_query": "modern apartments with dishwasher Bedford TX",
      "category": "",
      "h1_title": "Modern Apartments with Dishwasher",
      "h2_subtitle": "Explore modern apartments with a dishwasher in Bedford, TX. Enjoy convenience and style in a welcoming community at The Logan.",
      "page_copy": "Welcome to The Logan, where modern living comes together with convenient features like an in-unit dishwasher in the heart of Bedford, TX. Our beautifully designed one and two-bedroom floor plans are a perfect fit for those seeking contemporary homes with stylish touches and functionality.\n\nOur community doesn't stop at just modern appliances. Experience a range of exceptional amenities, including a refreshing swimming pool, fitness center, and vibrant pet play area. At The Logan, every aspect of our community is tailored to provide a fulfilling lifestyle, making it an ideal place to call home. Discover the ease of modern living and the comfort of elegance at our Bedford location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f6c13-0226-73e6-931c-35971dcc150f.webp",
      "featured_image_media": {
        "alt_text": "Stylish lounge area with a stone fireplace, comfortable seating, and modern art.",
        "public_id": "019f6c13-0226-73e6-931c-35971dcc150f",
        "storage_key": "property/5767160559304704/019f6c13-0226-73e6-931c-35971dcc150f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Apartments with Dishwasher - Bedford, TX",
      "seo_description": "Discover modern apartments with a dishwasher at The Logan in Bedford, TX. Enjoy convenience and style with top amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "custom",
      "page_item_url": "apartments-pool-fitness-center-76021-331",
      "search_query": "apartments with pool and fitness center 76021",
      "category": "",
      "h1_title": "Apartments with Pool & Fitness Center",
      "h2_subtitle": "Discover luxury apartments with a pool and fitness center in 76021. Enjoy unmatched amenities at The Logan in Bedford.",
      "page_copy": "Embrace a lifestyle of recreation and relaxation at The Logan, where you'll find apartments with a pool and fitness center in the 76021 area. Our community is designed for those who value wellness and leisure without sacrificing convenience. Nestled in Bedford, our one and two-bedroom layouts offer residents a modern sanctuary.\n\nTake advantage of our sparkling swimming pool and fully-equipped fitness center, perfect for staying active or unwinding after a long day. In addition to these amenities, residents enjoy features like chef's kitchens and hard floors, ensuring both style and functionality. Make The Logan your sanctuary and experience a perfect blend of comfort and activity today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f6c13-0226-73e6-931c-35971dcc150f.webp",
      "featured_image_media": {
        "alt_text": "Stylish lounge area with a stone fireplace, comfortable seating, and modern art.",
        "public_id": "019f6c13-0226-73e6-931c-35971dcc150f",
        "storage_key": "property/5767160559304704/019f6c13-0226-73e6-931c-35971dcc150f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool & Fitness Center - 76021",
      "seo_description": "Find apartments with a pool and fitness center at The Logan in Bedford, 76021. Enjoy modern amenities designed for an active and comfortable lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "custom",
      "page_item_url": "1-bedroom-apartments-bedford-tx-653",
      "search_query": "1 bedroom apartments bedford tx",
      "category": "",
      "h1_title": "1 Bedroom Apartments in Bedford, TX",
      "h2_subtitle": "Explore spacious 1 bedroom apartments in Bedford, TX at The Logan. Find your perfect home with modern features and amenities.",
      "page_copy": "Welcome to The Logan, where we offer beautifully designed 1 bedroom apartments in Bedford, TX. Each of our units is thoughtfully crafted to provide a modern haven, complete with high ceilings and chefs’ kitchens, offering the perfect setting for comfort and style.\n\nBeyond the apartment interiors, our community amenities elevate your living experience. Enjoy access to our sparkling swimming pool, engage in a fitness routine at our state-of-the-art gym, or relax with your furry friend at the dedicated pet play area. Situated in Bedford, The Logan is perfectly located for convenient living with a touch of luxury. Discover the vibrant lifestyle that awaits you in our community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f6c13-0226-73e6-931c-35971dcc150f.webp",
      "featured_image_media": {
        "alt_text": "Stylish lounge area with a stone fireplace, comfortable seating, and modern art.",
        "public_id": "019f6c13-0226-73e6-931c-35971dcc150f",
        "storage_key": "property/5767160559304704/019f6c13-0226-73e6-931c-35971dcc150f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Bedford, TX - The Logan",
      "seo_description": "Discover spacious 1 bedroom apartments at The Logan in Bedford, TX. Enjoy modern living with premier amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767160559304704",
      "source": "custom",
      "page_item_url": "2-bedroom-apartments-hurst-euless-bedford-739",
      "search_query": "2 bedroom apartments in hurst euless bedford",
      "category": "",
      "h1_title": "2 Bedroom Apartments in Hurst Euless Bedford",
      "h2_subtitle": "Find spacious 2 bedroom apartments in the Hurst Euless Bedford area. Experience an ideal blend of comfort and convenience at The Logan.",
      "page_copy": "Discover the perfect 2 bedroom apartments in the Hurst Euless Bedford area at The Logan. Our community offers elegant living spaces designed with high ceilings and open floor plans that provide ample room and style for you and your lifestyle. Each apartment is fitted with modern amenities, including a chef's kitchen and stylish hard floors.\n\nThe Logan takes community living to the next level with exceptional amenities like a sparkling swimming pool, a fully equipped fitness center, and a pet-friendly environment with a dedicated pet play area. Located ideally within the Hurst Euless Bedford region, our community ensures easy access to local conveniences while offering a vibrant place to call home. Welcome to a life of comfort and luxury.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019f6c13-0226-73e6-931c-35971dcc150f.webp",
      "featured_image_media": {
        "alt_text": "Stylish lounge area with a stone fireplace, comfortable seating, and modern art.",
        "public_id": "019f6c13-0226-73e6-931c-35971dcc150f",
        "storage_key": "property/5767160559304704/019f6c13-0226-73e6-931c-35971dcc150f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Hurst Euless Bedford",
      "seo_description": "Explore spacious 2 bedroom apartments at The Logan in the Hurst Euless Bedford area. Discover modern living with top amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2212"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2376471462"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a5e\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a5e\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4520341"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MBMPT8B"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "3"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_betterbot_script",
      "type": "STRING",
      "value": "<script src=\"https://thelogan.engine.betterbot.com/loader.js\" defer=\"defer\"></script>"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443251725"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/4d7p1k3xwkx"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/c977f703-a063-4a66-b388-317542d6b609"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "817-790-9390"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImgzY3lyZEVPSW1lL0V5ekVidE1nWXc9PSIsInZhbHVlIjoiWlpMQTltcTBORmhwd05vcjg0R0hRQT09IiwibWFjIjoiYjllNGM0MzA4ZTY2MGViZGU5Nzc0OWM2NjFlNzc0OWJkMDJlNjZhMWZiZTJiMTdhOTZkZjFhMWU2NmE3MDQzMyJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2212",
  "custom_repli_id": "2376471462",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a5e\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a5e\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4520341",
  "custom_google_gtm_id": "GTM-MBMPT8B",
  "custom_rollout_phase": "3",
  "custom_ads_subscription": "full_stack",
  "custom_betterbot_script": "<script src=\"https://thelogan.engine.betterbot.com/loader.js\" defer=\"defer\"></script>",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443251725",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/4d7p1k3xwkx",
  "custom_self_guided_tour_url": "https://selftournow.com/property/c977f703-a063-4a66-b388-317542d6b609",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "817-790-9390",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImgzY3lyZEVPSW1lL0V5ekVidE1nWXc9PSIsInZhbHVlIjoiWlpMQTltcTBORmhwd05vcjg0R0hRQT09IiwibWFjIjoiYjllNGM0MzA4ZTY2MGViZGU5Nzc0OWM2NjFlNzc0OWJkMDJlNjZhMWZiZTJiMTdhOTZkZjFhMWU2NmE3MDQzMyJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "958ecef5-43ce-4cea-9e53-d54136c43715",
  "custom_audioeye_site_hash": "8c73a88292811285b8491148807f2a69"
};

export const generatedAt = '2026-11-03T20:28:15.170Z';
